<template>
  <v-container class="grey lighten-5">
    <div class="my-3">
<!--
    <v-btn icon :to="{ path: '/' }">
-->
    <v-btn icon :to="returnPath">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <span class="display-1 px-3">{{AnalizeTypeCategory}}の分析を依頼する</span>
    </div>
    <v-form ref="mymachine_form">
        <v-stepper
            v-model="e6"
            vertical
            editable
        >
          <v-stepper-step :complete="e6 > 1" step="1" @click="changeStepper(1)" color="teal darken-1">
          案件情報の入力
          </v-stepper-step>
          <v-stepper-content step="1" >
            <v-card >          
              <v-row dense>               
                <v-col cols="12"  lg="12" md='12' sm='12' xs="12">
                  <v-card flat outlined class="pa-3">
                    <div class="subtitle-2 mb-2">
                      <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
                      <span class="primary--text">案件情報の入力について</span></div>
                      <p class="caption">
                        お客様の管理情報（注文番号など）を入力してください。
                        <br>
                        <br>
                        お客様が請求を識別しやすい情報を自由に入力してください。<br>
                      </p>
                  </v-card>
                </v-col>
              </v-row>
              <v-row dense class="mt-3">               
<!--
                <v-col cols="7"  lg="7" md='7' sm='10' xs="10">
                  <v-tooltip top color="grey darken-2">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="ApplicationName"
                        label="案件名"
                        dense
                        counter=80
                        @input="$v.ApplicationName.$touch()"
                        :error-messages="ApplicationNameErrors"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <span>分析依頼を識別する名称を入力してください。入力は任意です。</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="1"  lg="1" md='1' sm='2' xs="2" dense>
                </v-col>
-->
                <v-col cols="4"  lg="4" md='4' sm='10' xs="10">
                  <v-tooltip top color="grey darken-2">
                    <template v-slot:activator="{ on }">
                      <v-text-field 
                        v-on="on"
                        v-model="CustomerOrderNumber" 
                        :label="getItemName('注文番号')[AnalizeTypeCategory+'label']"
                        dense
                        counter=20
                        @input="$v.CustomerOrderNumber.$touch()"
                        :error-messages="CustomerOrderNumberErrors"
                        :message="getItemName('注文番号')[AnalizeTypeCategory+'message']"
                      ></v-text-field>
                    </template>
                    <span class="wrap-text">{{getItemName('注文番号')[AnalizeTypeCategory+'description']}}</span>
                  </v-tooltip>
                </v-col>
              </v-row>

              <v-btn class="mx-2" color="primary" @click="changeStepper(2)" outlined>次へ</v-btn>              
            </v-card>            
          </v-stepper-content>


          <v-stepper-step :complete="e6 > 2" step="2" @click="changeStepper(2)" color="teal darken-1">
          納品明細書の送付先
          </v-stepper-step>
          <v-stepper-content step="2" >
            <v-card >

              <v-row dense>               
                <v-col cols="12"  lg="12" md='12' sm='12' xs="12">
                  <v-card flat outlined class="pa-3">
                    <div class="subtitle-2 mb-2"><v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
                    <span class="primary--text"> 納品明細書の送付先について</span></div>
                    <p class="caption">
                      分析・診断の納品明細書の送付先です。<br>
                      OilMatrix ジャパン・アナリストに登録済みの送付先から選択してください。<br>
                      新しい送付先を追加したい場合は、弊社担当営業までご連絡ください。<br>
                      <br>
                      <!--
                      報告書／納品明細書をPDFファイルで送付先担当者様のメールアドレス宛てに送付いたします。
                      報告書／納品明細書の郵送をご希望の場合は「郵送のみ」または「郵送＋メール」を選択して下さい。<br>
                      -->
                      納品明細書の郵送をご希望の場合は「郵送＋ダウンロード」を選択して下さい。<br>
                      納品明細書のをメールでの送付ご希望の場合は「メール＋ダウンロード」を選択して下さい。<br>
                      納品明細書の送付先担当者様のメールアドレス宛てに送付いたします。                    </p>
                  </v-card>
                </v-col>
              </v-row>

              <v-row dense class="mt-2">
                <v-col cols="6" lg="6" md="6" sm="6" xs="12">
                  <v-select
                    v-model="Shipping"
                    label="納品明細書の送付方法"
                    :items="shippingOptions"
                    dense
                    filled
                  ></v-select>
                </v-col>
              </v-row>

              <v-row v-if="!isChangePayment" dense class="mt-0">
                <v-col dense cols="12">
                  <div class="caption red--text mb-2">納品明細書を送付先は変更できません。下記以外を送付先に指定したい場合はご連絡ください。</div>
                </v-col>
              </v-row>

              <v-row dense class="mt-0">
                <v-col dense cols="7"  lg="7" md='7' sm='7' xs="12">

                  <v-select v-model="Payment" label="納品明細書の送付先事業所" dense
                    :items="officeList"
                    item-value="OfficeID"
                    item-text="Name"
                    @change="changePayment"
                    :disabled="!isChangePayment"
                    filled
                  >
                    <template slot='selection' slot-scope='data'>
                      {{ data.item.CompanyName }} {{ data.item.Name }}
                    </template>
                    <template slot="item" slot-scope="data">
                      <!-- HTML that describe how select should render items when the select is open -->
                      {{ data.item.CompanyName }} {{ data.item.Name }}
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="5"  lg="5" md='5' sm='5' xs="10" dense>
                  <v-select v-model="PayPICID" label="ご担当者様名"
                    dense
                    :items="PayEmployee"
                    item-value="EmployeeID"
                    item-text="Name"
                    @change="changePayEmployee()"
                    :disabled="!isChangePayment"
                    filled
                    no-data-text="登録されている担当者情報がありません"
                  >
<!--
                    @input="$v.PayPICID.$touch()"
                    @blur="$v.PayPICID.$touch()"
                    :error-messages="PayPICIDErrors"
                    :error="$v.PayPICID.$error"
-->          
                    <template slot='selection' slot-scope='data'>
                      {{ data.item.DeptName }} {{ data.item.Name }}
                    </template>
                    <template slot="item" slot-scope="data">
                      <!-- HTML that describe how select should render items when the select is open -->
                      {{ data.item.DeptName }} {{ data.item.Name }}
                    </template>
                  </v-select>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="2"  lg="2" md='2' sm='2' xs="10" dense>
                  <v-text-field v-model="PayZip" label="郵便番号" dense
                         disabled
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="10"  lg="10" md='10' sm='10' xs="10" dense>
                  <v-text-field v-model="PayAddress" label="ご住所" dense
                         disabled
                    >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6"  lg="6" md='6' sm='6' xs="12" dense>
                  <v-text-field v-model="PayCompany" label="会社名" dense
                         disabled
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="3"  lg="3" md='3' sm='6' xs="12" dense>
                  <v-text-field v-model="PayOffice" label="事業所名" dense disabled></v-text-field>
                </v-col>
                <v-col cols="3"  lg="3" md='3' sm='6' xs="12" dense>
                  <v-text-field v-model="PayDept" label="部署名" dense disabled></v-text-field>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="4"  lg="4" md='4' sm='6' xs="12" dense>
                 <v-text-field v-model="PayTel" label="お電話番号" dense
                         disabled
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="4"  lg="4" md='4' sm='6' xs="12" dense>
                  <v-text-field v-model="PayFAX" label="FAX番号" dense disabled></v-text-field>
                </v-col>
                <v-col cols="4"  lg="4" md='4' sm='6' xs="12" dense>
                 <v-text-field v-model="Payemail" label="メールアドレス" dense
                         disabled
                    >
                  </v-text-field>
                </v-col>
              </v-row>

              <v-btn class="mx-2" color="primary" @click="changeStepper(3)" outlined>次へ</v-btn>
            </v-card >
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 3" step="3" @click="changeStepper(3)" color="teal darken-1">
          報告書の送付先
          </v-stepper-step>
          <v-stepper-content step="3" >
            <v-card >
              <v-row class="mt-2" dense>               
                <v-col cols="12" dense>
                  <v-switch
                    v-model="SameDeliveryAsOrderer"
                    class="ml-3 caption"
                    label="依頼者と同じ"
                    hide-details
                    @change="clickSameDeliveryAsOrderer"
                  >
                  </v-switch>
                </v-col>
                <v-col cols="7"  lg="7" md='7' sm='7' xs="7">
                  <v-select v-model="Delivery" label="報告書送付先の事業所"
                    :items="officeList"
                    item-value="OfficeID"
                    item-text="Name"
                    @change="changeDelivery"
                    data-changeReport
                    filled
                    v-bind:disabled="isRepDisable"
                  >
                    <template slot='selection' slot-scope='data'>
                      {{ data.item.CompanyName }} {{ data.item.Name }}
                    </template>
                    <template slot="item" slot-scope="data">
                      <!-- HTML that describe how select should render items when the select is open -->
                      {{ data.item.CompanyName }} {{ data.item.Name }}
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="5"  lg="5" md='5' sm='5' xs="12" dense>
                  <v-select v-model="DelvPICID" label="ご担当者様名"
                    dense
                    :items="DelvEmployee"
                    item-value="EmployeeID"
                    item-text="Name"
                    @change="changeDelvEmployee()"
                    filled
                    v-bind:disabled="isRepDisable"
                    @input="$v.DelvPICID.$touch()"
                    @blur="$v.DelvPICID.$touch()"
                    :error-messages="DelvPICIDErrors"
                    :error="$v.DelvPICID.$error"
                    no-data-text="登録されている担当者情報がありません"
                  >
                    <template slot='selection' slot-scope='data'>
                      {{ data.item.DeptName }} {{ data.item.Name }}
                    </template>
                    <template slot="item" slot-scope="data">
                      <!-- HTML that describe how select should render items when the select is open -->
                      {{ data.item.DeptName }} {{ data.item.Name }}
                    </template>
                  </v-select>
                </v-col>
                </v-row>

<!-- 報告書の送付先を分離-->
                <v-row dense>
                  <v-col cols="2"  lg="2" md='2' sm='2' xs="10" dense>
                    <v-text-field v-model="DelvZip" label="郵便番号" dense
                          disabled
                      >
                    </v-text-field>
                  </v-col>
                  <v-col cols="10"  lg="10" md='10' sm='10' xs="10" dense>
                    <v-text-field v-model="DelvAddress" label="ご住所" dense
                          disabled
                      >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="6"  lg="6" md='6' sm='6' xs="12" dense>
                    <v-text-field v-model="DelvCompany" label="会社名" dense
                          disabled
                      >
                    </v-text-field>
                  </v-col>
                  <v-col cols="3"  lg="3" md='3' sm='6' xs="12" dense>
                    <v-text-field v-model="DelvOffice" label="事業所名" dense disabled></v-text-field>
                  </v-col>
                  <v-col cols="3"  lg="3" md='3' sm='6' xs="12" dense>
                    <v-text-field v-model="DelvDept" label="部署名" dense disabled></v-text-field>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="4"  lg="4" md='4' sm='6' xs="12" dense>
                  <v-text-field v-model="DelvTel" label="お電話番号" dense
                          disabled
                      >
                    </v-text-field>
                  </v-col>
                  <v-col cols="4"  lg="4" md='4' sm='6' xs="12" dense>
                    <v-text-field v-model="DelvFAX" label="FAX番号" dense disabled></v-text-field>
                  </v-col>
                  <v-col cols="4"  lg="4" md='4' sm='6' xs="12" dense>
                  <v-text-field v-model="Delvemail" label="メールアドレス" dense
                          disabled
                      >
                    </v-text-field>
                  </v-col>
                </v-row>




              <v-btn class="mx-2" color="primary" @click="changeStepper(4)" outlined>次へ</v-btn>
            </v-card >
          </v-stepper-content>




          <v-stepper-step :complete="e6 > 4" step="4" @click="changeStepper(4)" color="teal darken-1">
          報告書の宛名
          </v-stepper-step>
          <v-stepper-content step="4" >
            <v-card >
                <v-row dense>               
                  <v-col cols="12"  lg="12" md='12' sm='12' xs="12">
                    <v-card flat outlined class="pa-3">
                      <div class="subtitle-2 mb-2"><v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon><span class="primary--text">報告書の宛名について</span></div>
                      <p class="caption">
                        分析・診断結果報告書に記載されるの宛名です。<br>
                        <br>
                        報告書の宛名を変更しない場合（「報告書の宛名を変更する」がチェックされていない場合）、報告書の郵送先の事業所名、ご担当者様名で報告書を作成します。<br>
                        報告書の宛名を任意で入力する場合は「報告書の宛名を変更する」をチェックして報告書に記載する会社名・事業所・部署・ご担当者様の氏名を入力してください。
                        </p>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12" xl="3" lg="4" md='6' sm='8' xs="12" dense>
                    <v-tooltip top color="grey darken-2">
                      <template v-slot:activator="{ on }">
                        <v-switch
                          v-on="on"
                          class="ml-3"
                          v-model="CustomRepCheckbox"
                          label="報告書の宛名を変更する"
                          @change="clickCustomRepCheckbox"
                        >
<!--
                          v-bind:disabled="SameDeliveryAsOrderer"
-->
                      </v-switch>
                      </template>
                      <span>報告書の宛名を任意に設定したい場合はチェックします。</span>
                    </v-tooltip>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="6"  lg="6" md='6' sm='6' xs="12" dense>
                    <v-text-field v-model="RepCompany" label="会社名"
                        dense
                        v-bind:disabled="CustomRepDisabled"
                        class="black--text"
                        counter=30
                        @input="$v.RepCompany.$touch()"
                        :error-messages="RepCompanyErrors"
                        :error="$v.RepCompany.$error"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" lg="3" md='3' sm='6' xs="12" dense>
                    <v-text-field v-model="RepOffice" label="事業所名"
                        dense
                        v-bind:disabled="CustomRepDisabled"
                        counter=30
                        @input="$v.RepOffice.$touch()"
                        :error-messages="RepOfficeErrors"
                        :error="$v.RepOffice.$error"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" lg="3" md='3' sm='6' xs="12" dense>
                    <v-text-field v-model="RepDept" label="部署名" dense
                        v-bind:disabled="CustomRepDisabled"
                        counter=30
                        @input="$v.RepDept.$touch()"
                        :error-messages="RepDeptErrors"
                        :error="$v.RepDept.$error"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" lg="3" md='3' sm='6' xs="12" dense>
                    <v-text-field v-model="RepPIC" label="ご担当者様氏名" dense
                        v-bind:disabled="CustomRepDisabled"
                        counter=30
                        @input="$v.RepPIC.$touch()"
                        @blur="$v.RepPIC.$touch()"
                        :error-messages="RepPICErrors"
                        :error="$v.RepPIC.$error"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-btn class="mx-2" color="primary" @click="changeStepper(5)" outlined>次へ</v-btn>
            </v-card >
          </v-stepper-content>


<!--
          <v-stepper-step :complete="e6 > 4" step="4" editable color="teal darken-1">
          納品明細書の送付先
          </v-stepper-step>
          <v-stepper-content step="4" >
            <v-card >
              <v-row dense>               
                <v-col cols="12"  lg="12" md='12' sm='12' xs="12">
                  <v-card flat outlined class="pa-3">
                    <div class="subtitle-2 mb-2"><v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
                    <span class="primary--text">納品明細書の宛先について</span></div>
                    <p class="caption">
                      納品明細書の宛先、送付先です。<br>
                      <br>
                      登録済みの送付先から選択してください。<br>
                      納品明細書の宛先を追加したい場合は、弊社担当営業までご連絡ください。
                      </p>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" dense>
                  <v-switch
                    v-model="SamePayAsDelivery"
                    class="ml-3 caption"
                    label="報告書の送付先と同じ"
                    hide-details
                    @change="clickSamePayAsDelivery"
                  >
                  </v-switch>
                </v-col>
                <v-col cols="7"  lg="7" md='7' sm='7' xs="12">
                  <v-select v-model="Payment" label="納品明細書の宛先事業所" dense
                    :items="officeList"
                    item-value="OfficeID"
                    item-text="Name"
                    v-bind:disabled="SamePayAsDelivery"
                    @change="changePayment"
                    filled
                  >
                    <template slot='selection' slot-scope='data'>
                      {{ data.item.CompanyName }} {{ data.item.Name }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.CompanyName }} {{ data.item.Name }}
                    </template>
                  </v-select>
                </v-col>

                <v-col cols="5"  lg="5" md='5' sm='5' xs="10" dense>
                  <v-select v-model="PayPICID" label="ご担当者様名"
                    dense
                    :items="PayEmployee"
                    item-value="EmployeeID"
                    item-text="Name"
                    v-bind:disabled="SamePayAsDelivery"
                    @change="changePayEmployee()"
                    filled
                    @input="$v.PayPICID.$touch()"
                    @blur="$v.PayPICID.$touch()"
                    :error-messages="PayPICIDErrors"
                    :error="$v.PayPICID.$error"
                    no-data-text="登録されている担当者情報がありません"
                  >
                    <template slot='selection' slot-scope='data'>
                      {{ data.item.DeptName }} {{ data.item.Name }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.DeptName }} {{ data.item.Name }}
                    </template>
                  </v-select>

                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="2"  lg="2" md='2' sm='2' xs="10" dense>
                 <v-text-field v-model="PayZip" label="郵便番号" dense
                        disabled
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="8"  lg="8" md='8' sm='8' xs="10" dense>
                  <v-text-field v-model="PayAddress" label="ご住所" dense
                        disabled
                  >
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="6"  lg="6" md='6' sm='6' xs="12" dense>
                 <v-text-field v-model="PayCompany" label="会社名" dense
                        disabled
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="3"  lg="3" md='3' sm='3' xs="12" dense>
                  <v-text-field v-model="PayOffice" label="事業所名" dense disabled></v-text-field>
                </v-col>
                <v-col cols="3"  lg="3" md='3' sm='3' xs="10" dense>
                  <v-text-field v-model="PayDept" label="部署名" dense disabled></v-text-field>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="6"  lg="6" md='6' sm='6' xs="10" dense>
                  <v-text-field v-model="PayTel" label="お電話番号" dense
                        disabled
                    >
                  </v-text-field>
                </v-col>
                <v-col cols="6"  lg="6" md='6' sm='6' xs="10" dense>
                  <v-text-field v-model="PayFAX" label="FAX番号" dense disabled></v-text-field>
                </v-col>
              </v-row>

              <v-btn class="mx-2" color="primary" @click="changeStepper(5)" outlined>次へ</v-btn>
            </v-card >
          </v-stepper-content>
-->

          <v-stepper-step :complete="e6 > 5" step="5" @click="changeStepper(5)" color="teal darken-1">
          分析サンプル
          </v-stepper-step>
          <v-stepper-content step="5" >

            <v-card v-if="!isQuote">
              <v-row dense>               
                <v-col cols="12" lg="12" md='12' sm='12' xs="12">
                  <v-card flat outlined class="pa-3">
                    <div class="subtitle-2 mb-2"><v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
                    <span class="primary--text">分析サンプルの指定について</span></div>
                    <p class="caption">
                      分析依頼するサンプルを採油済みサンプルリストより選択してください。<br>
                      <br>
                      報告書の宛名、送付先、納品明細書の送付先が同じ場合は、１件の依頼で複数のサンプルの分析をご依頼頂くことができます。<br>
                      報告書の宛名、送付先、納品明細書の送付先が異なる場合は、お手数ですが別の分析依頼としてご依頼ください。<br>
                      <br>
                      サンプル毎にご希望の分析納期をご指定いただけます。<br>
                      ただし、OilMatrix及び分析・診断サービスの混雑状況によってはご希望に添えない場合がございます。ご理解の程よろしくお願いいたします。
                    </p>
                    <p class="caption">
                      採油済みの分析サンプルが一覧に表示されていない場合は、以下の理由が考えられます。<br>
                      ・すでに分析依頼済みである。<br>
                      ・危険物が含まれる分析サンプルで、ジャパン・アナリストへの確認がお済みでない（「確認した」がチェックされていない）。<br>
                      トップページの「採油済みサンプル一覧」から分析サンプル情報を確認してください。
                    </p>

                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense>
                  <v-data-table
                    :headers="headers"
                    :items="samples"
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    :search="search"
                    v-model="selectedSamples"
                    show-select
                    class="elevation-1"
                    hide-default-footer
                    no-data-text="データがありません。"          
                    @page-count="pageCount = $event"
                    @input="$v.selectedSamples.$touch()"
                    @item-selected="selectSamples"
                    @toggle-select-all="selectAllSamples"
                    :error-messages="selectedSampleErrors"
                  >
                  <template v-slot:[`item.Price`]="{ item }">
                    <span > &yen; {{ Number(item.Price).toLocaleString() }} </span>
                  </template>

                  <template v-slot:[`header.HazardousMaterialsConfirmed`]="{ header }">
                    <div class="mt-4 text-center">{{ header.text }}</div>
                  </template>
                  <template v-slot:[`item.HazardousMaterialsConfirmed`]="{ item }">
                    <div v-if="item.isHazardousMaterials==0" class="text-center">
                      <v-icon color="gray">mdi-minus</v-icon>
                    </div>
                    <div v-else-if="item.HazardousMaterialsConfirmed==1" class="text-center">
                      <v-icon color="red">mdi-checkbox-marked-circle</v-icon>
                    </div>
                    <div v-else class="text-center">
                      <v-icon color="gray">mdi-checkbox-marked-circle</v-icon>
                    </div>
                  </template>

                  </v-data-table>
                  <span class="px-3 red--text caption" v-if ="isSelected">1つ以上の分析サンプルを選択してください</span>
                  <span class="px-3 red--text caption" v-if ="isDuplicate">選択された分析サンプルはすでに依頼されています。ご依頼内容をご確認ください</span>
                  <span class="px-3 red--text caption" v-if ="isMaxSamples">１回のご依頼は{{maxSamples}}サンプルまででお願いいたします。</span>
                </v-col>

                <v-col cols="12"  lg="12" md='12' sm='12' xs="12">
                  <v-pagination
                    v-model="page"
                    :total-visible="totalVisible"
                    :length="pageCount"
                    color="amber black--text"
                    light 
                    circle
                  >
                  </v-pagination>

                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="2" dense>
                  <v-tooltip right color="grey darken-2">
                    <template v-slot:activator="{ on }">
                    <div class="title" v-on="on">
                      分析料金
                    </div>
                    </template>
                    <span>{{getItemName('分析料金')[AnalizeTypeCategory+'description']}}</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" dense>
                  <div class="title">
                    {{(TotalFee + SurplusFee).toLocaleString()}} 円（税抜き）
                    <span class="px-3 body">{{selectedSamples.length}}/{{samples.length}}サンプル選択中</span>
                  </div>
                  <div v-if="SurplusCount > 0" class="">
                    （サンプル返却手数料
                    {{SurplusFee.toLocaleString()}} 円を含む）
                  </div>
                </v-col>
              </v-row>

              <v-btn class="mx-2" color="primary" @click="changeStepper(6)" outlined>次へ</v-btn>
            </v-card >

            <v-card v-if="isQuote">
              <v-row dense>               
                <v-col cols="12" lg="12" md='12' sm='12' xs="12">
                  <v-card flat outlined class="pa-3">
                    <div class="subtitle-2 mb-2"><v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
                    <span class="primary--text">分析サンプルについて</span></div>
                    <p class="caption">
                      お見積りいただいたサンプルが設定されています<br>
                      <br>
                      オイル名／オイルメーカー、採取日、サンプルのボトル数を入力して下さい。<br>
                      サンプル毎にご希望の分析納期をご指定いただけます。<br>
                      ただし、OilMatrix及び分析・診断サービスの混雑状況によってはご希望に添えない場合がございます。ご理解の程よろしくお願いいたします。
                    </p>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense>
                  <v-data-table
                    :headers="quoteSampleheaders"
                    :items="selectedSamples"
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    :search="search"
                    class="elevation-1"
                    hide-default-footer
                    no-data-text="データがありません。"          
                    @page-count="pageCount = $event"
                    @click:row="editSample"
                  >

                  <template v-slot:[`item.Checked`]="{ item }">
                    <div v-if="item.Checked" class="text-center">
                      <v-icon color="green">mdi-checkbox-marked-circle</v-icon>
                    </div>
                    <div v-else class="text-center">
                      <v-icon color="gray">mdi-checkbox-marked-circle</v-icon>
                    </div>
                  </template>
                  <template v-slot:[`item.DeliveryPeriod`]="{ item }">
                    <span>{{ item.DeliveryPeriod }}</span>
                  </template>
                  <template v-slot:[`item.Fee`]="{ item }">
                    <span>{{ Number(item.Fee).toLocaleString() }} </span>
                  </template>
                  <template v-slot:[`item.AnalizeSetName`]="{ item }">
                    <div v-if="item.AnalizeSetName">{{item.AnalizeSetName}}</div>
                    <div v-else>指定なし</div>
                  </template>
                  <template v-slot:[`item.AnalizeItems`]="{ item }">
                    <div v-if="item.AnalizeItems.length > 0" class="text-center">あり</div>
                    <div v-else class="text-center">なし</div>
                  </template>
                  <template v-slot:[`item.OilTypeCategoryText`]="{ item }">
                    <span>{{ item.OilTypeCategoryText }}／{{ item.OilTypeText }}</span>
                  </template>
                  <template v-slot:[`item.OilModelNumber`]="{ item }">
                    <span  v-if="item.OilModelNumber">{{ item.OilmakerID }}／{{ item.OilModelNumber }}</span>
                    <span  v-else style="color:red">未入力</span>
                  </template>
                  <template v-slot:[`item.OilUsageTime`]="{ item }">
                    <span v-if="item.OilUsageTime"> {{ item.OilUsageTime }} {{ item.OilUsageTimeUnitText }}</span>
                    <span v-else-if="item.Checked" style="color:gray">指定なし</span>
                    <span v-else style="color:red">未入力</span>
                  </template>

                  <template v-slot:[`item.SamplingAt`]="{ item }">
                    <span v-if="item.SamplingAt"> {{ item.SamplingAt }}</span>
                    <span v-else style="color:red">未入力</span>
                  </template>

                  <template v-slot:[`item.HazardousMaterialsConfirmed`]="{ item }">
                    <div v-if="item.isHazardousMaterials==0" class="text-center">
                      <v-icon color="gray">mdi-minus</v-icon>
                    </div>
                    <div v-else-if="item.HazardousMaterialsConfirmed==1" class="text-center">
                      <v-icon color="red">mdi-checkbox-marked-circle</v-icon>
                    </div>
                    <div v-else class="text-center">
                      <v-icon color="gray">mdi-checkbox-marked-circle</v-icon>
                    </div>
                  </template>

                  <template v-slot:[`header.HazardousMaterialsConfirmed`]="{ header }">
                    <div class="text-center">{{ header.text }}</div>
                  </template>


                  </v-data-table>
                  <span class="px-3 red--text caption" v-if ="isSelected">1つ以上の分析サンプルを選択してください</span>
                  <span class="px-3 red--text caption" v-if ="isDuplicate ">選択された分析サンプルはすでに依頼されています。ご依頼内容をご確認ください</span>
                  <span class="px-3 red--text caption" v-if ="hasNoChecnSample ">未確認（サンプル名や採取日が未入力）のサンプルがあります。</span>
                </v-col>

                <v-col cols="12" dense>
                  <v-tooltip left color="grey darken-2">
                    <template v-slot:activator="{ on }">
                    <div class="title" v-on="on">
                      分析料金
                    </div>
                    </template>
                    <span>{{getItemName('分析料金')[AnalizeTypeCategory+'description']}}</span>
                  </v-tooltip>
                  <div class="title">
                    {{(TotalFee + SurplusFee).toLocaleString()}} 円（税抜き）
                    <span class="px-3 body">{{checked}}/{{selectedSamples.length}}サンプル確認済み</span>
                  </div>
                  <div v-if="SurplusCount > 0" class="">
                    （サンプル返却手数料
                    {{SurplusFee.toLocaleString()}} 円を含む）
                  </div>
                  
                  <div v-if="DiscountInfo.code" class="title red--text">
                    Web割引
                    - {{Number(DiscountInfo.discount).toLocaleString()}} 円
                  </div>
                </v-col>

              </v-row>
              <v-row>
                <v-col cols="12"  lg="12" md='12' sm='12' xs="12">
                  <v-pagination
                    v-model="page"
                    :total-visible="totalVisible"
                    :length="pageCount"
                    color="amber black--text"
                    light 
                    circle
                  >
                  </v-pagination>

                </v-col>
              </v-row>
              <v-btn class="mx-2" color="primary" @click="changeStepper(6)" outlined>次へ</v-btn>
            </v-card>

<!--
            <v-card v-if="isQuote">
              ここには見積からの分析依頼のときのサンプル情報入力画面が出ます
              <v-card v-for="sample of selectedSamples" outlined class="my-2" v-bind:key="sample.id">
                <v-app-bar
                  flat
                  color="rgba(0, 0, 0, 0)"
                  class="ma-0 pa-0"
                  max-height="32px"
                >
                  <v-toolbar-title class="text-h6 black--text pl-0 mt-0">
                    <v-chip v-if="sample.OilTypeCategoryText=='潤滑油'" small color="green" class="white--text mr-2">{{ sample.OilTypeCategoryText }}</v-chip>
                    <v-chip v-else-if="sample.OilTypeCategoryText=='燃料'" small color="yellow" class="black--text mr-2">{{ sample.OilTypeCategoryText }}</v-chip>
                    <v-chip v-else-if="sample.OilTypeCategoryText=='グリス'" small color="blue" class="black--text mr-2">{{ sample.OilTypeCategoryText }}</v-chip>
                    {{ sample.Name }}
                  </v-toolbar-title>
                </v-app-bar>

                <v-card-subtitle class="pb-0">{{ sample.OilTypeText }}</v-card-subtitle>
                <v-card-title class="pt-0 pb-0 mb-0">
                  <v-chip small label color="gray" class="label-chip">分析セット</v-chip><div class="mr-2">{{ sample.AnalizeTypeGroupName }}</div> <div v-if="sample.AnalizeSet">{{ sample.AnalizeSetName }}</div><div v-else>（分析セット指定なし）</div>
                </v-card-title>
                <v-card-title class="pt-0 pb-0 mb-0">
                  <v-chip small label color="gray" class="label-chip">分析料金</v-chip><div>{{ Number(sample.Fee) }} 円（税抜き）</div>
                </v-card-title>
<v-card-text class="mt-3 ml-2">
            <v-row dense>
              <v-col cols="10" md="3" class="align-end" dense> 
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="sample.OilmakerID"
                      label="使用オイルメーカー"
                      dense
                      counter=20
                      @input="$v.OilmakerID.$touch()"
                      @blur="$v.OilmakerID.$touch()"
                      :error-messages="OilmakerIDErrors"
                      >
                    </v-text-field>
                  </template>
                  <span>依頼するこの機器で使用しているオイルのメーカーを入力します。</span>
                </v-tooltip>
              </v-col>
              <v-col cols="1" lg="1" md='1' sm='2' xs="2" dense>
                <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
              </v-col>
              <v-col cols="10" md="7" class="align-end" dense> 
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="sample.OilModelNumber"
                      label="使用オイル銘柄・番手"
                      dense
                      counter=78
                      @input="$v.OilModelNumber.$touch()"
                      @blur="$v.OilModelNumber.$touch()"
                      :error-messages="OilModelNumberErrors"
                    ></v-text-field>
                  </template>
                  <span>この機器で使用しているオイルの銘柄、番手を入力します。</span>
                </v-tooltip>
              </v-col>
              <v-col cols="1" lg="1" md='1' sm='2' xs="2" dense>
                <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="6" xl="2" lg="3" md='4' sm='5' xs="6" class="align-end" dense>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="sample.OilUsageTime"
                      label="オイル使用時間"
                      dense
                      @input="$v.OilUsageTime.$touch()"
                      :error-messages="OilUsageTimeErrors"
                    ></v-text-field>
                  </template>
                  <span>オイル交換後のオイルの使用時間を入力します。</span>
                </v-tooltip>
              </v-col>
              <v-col cols="4" xl="1" lg="2" md='2' sm='4' xs="4" dense>
                <v-select v-model="sample.OilUsageTimeUnit" label="単位" dense :items="useUnits" item-value="Value" item-text="Text"
                  clearable
                  @change="changeOilUsageTimeUnit()"
                ></v-select>
              </v-col>
              <v-col cols="1"  lg="1" md='1' sm='2' xs="2" dense>
              </v-col>
              <v-col cols="5" md="3" class="align-end" dense> 
              </v-col>
            </v-row>

          <v-row dense>
            <v-col cols="8" lg="2" md="3" sm='4' xs="8" dense>
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="sample.SamplingAt"
                    label="サンプル採取日"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @input="$v.sample.SamplingAt.$touch()"
                    :error-messages="SamplingAtErrors"

                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="sample.SamplingAt"
                  @input="menu2 = false"
                  locale="ja"
                ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="2" lg="1" md='1' sm='1' xs="2" align-self="center" dense>
              <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
            </v-col>

            <v-col cols="8" lg="2" md="3" sm='4' xs="8" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="sample.BottleCount"
                    label="ボトル数"
                    v-on="on"
                    @input="$v.BottleCount.$touch()"
                    :error-messages="BottleCountErrors"
                  ></v-text-field>
                </template>
                <span>サンプルが2本以上に分かれる場合はサンプルの本数を入力します。</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" lg="1" md='1' sm='1' xs="2" align-self="center" dense>
              <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
            </v-col>
              
            <v-col cols="12" lg="12" md="12" dense>
              <span class="caption">サンプルメモ（ジャパン・アナリストへの伝達事項）</span>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-textarea v-model="sample.SampleMemo"
                    v-on="on"
                    dense
                    filled
                    counter=64
                    @input="$v.SampleMemo.$touch()"
                    :error-messages="SampleMemoErrors"
                  ></v-textarea>
                </template>
                <span>サンプルや分析内容について、ジャパン・アナリストへの伝達事項があれば入力してください。</span>
              </v-tooltip>
            </v-col>
          </v-row>
</v-card-text>
              </v-card>

            </v-card >
-->
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 6" step="6" @click="changeStepper(6)" color="teal darken-1">
          <span>分析・診断サービス申込み</span>
          </v-stepper-step>
          <v-stepper-content step="6" >

                <v-row>
                  <v-col cols="12"  lg="12" md='12' sm='12' xs="12">
                  <v-card flat outlined class="pa-3 mb-3">
                    <div class="subtitle-2"><v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
                    <span class="primary--text">分析・診断サービスの申し込みについて</span></div>
                    <p class="caption">
                      <br>
                      弊社に分析をご依頼いただく前に「ジャパン・アナリスト株式会社 分析業務委託約款」（以下「本約款」といいます。）をご一読ください。<br>
                      本約款が適用されることに同意いただける場合は下記のチェック欄にチェックを入れてください。<br>
                    </p>
                    <span class="mr-1 caption">ジャパン・アナリスト株式会社 分析業務委託約款 は</span>
                    <v-btn
                      text
                      min-height="20"
                      target="_blank"
                      class="x-small align-center"
                      @click="openAgreement()"
                    >
                      <span class="text-left">こちら</span>
                    </v-btn>
                    <span class="mr-1 caption">からご確認いただけます。</span>
                    <v-checkbox
                      v-model="agreement"
                      class="agree-text" 
                      label="ジャパン・アナリスト株式会社 分析業務委託約款に同意する"
                    ></v-checkbox>
                  </v-card>

                  <v-tooltip top color="grey darken-2">
                    <template v-slot:activator="{ on }">
                      <v-btn
                      v-bind:disabled="!agreement"
                      v-on="on"
                      rounded 
                      block 
                      color="amber darken-1" 
                      @click="validationApplication" 
                      data-createApplication>
                        <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
                          依頼内容を確認する
                      </v-btn>
                    </template>
                    <span>クリックすると、依頼内容の確認画面が開きます</span>
                  </v-tooltip>
                  </v-col>
                </v-row>

          </v-stepper-content>
        </v-stepper>
        </v-form>

        <!-- 見積サンプル編集ダイアログ -->
        <v-dialog
          v-model="doEditSample"
          persistent
          max-width="70%"
        >
          <v-card class="px-2 py-2">
            <v-app-bar
              flat
              color="rgba(0, 0, 0, 0)"
              class="ma-0 pa-0"
            >
              <v-toolbar-title class="text-h6 black--text pl-0 mx-0">
                <v-chip v-if="this.sample.OilTypeCategoryText=='潤滑油'" color="green" class="white--text mr-2">{{ sample.OilTypeCategoryText }}</v-chip>
                <v-chip v-else-if="sample.OilTypeCategoryText=='燃料'" color="yellow" class="black--text mr-2">{{ sample.OilTypeCategoryText }}</v-chip>
                <v-chip v-else-if="sample.OilTypeCategoryText=='グリス'" color="blue" class="black--text mr-2">{{ sample.OilTypeCategoryText }}</v-chip>
                {{ sample.Name }}
              </v-toolbar-title>
            </v-app-bar>

            <v-card-subtitle class="pb-0">{{ sample.OilTypeText }}</v-card-subtitle>

            <v-card-title class="pt-0 pb-0 mb-0">
              <v-chip small label color="gray" class="mr-2" style="width: 120px">分析セット</v-chip>
              <div class="mr-2">{{ sample.AnalizeTypeGroupName }}</div> <div v-if="sample.AnalizeSet">{{ sample.AnalizeSetName }}</div><div v-else>（分析セット指定なし）</div>
            </v-card-title>
            <v-card-title class="pt-0 pb-0 mb-0">
              <v-chip small label color="gray" class="mr-2" style="width: 120px">個別分析項目</v-chip>
              <v-chip v-show="sample.AnalizeItemNames" v-for="a of sample.AnalizeItemNames" v-bind:key="a.Value" class="ml-4 mt-1 mb-1 white--text" color="green darken-3">{{ a.Text }}</v-chip>
            </v-card-title>
            <v-card-title class="pt-0 pb-0 mb-0">
              <v-chip small label color="gray" class="mr-2" style="width: 120px">オプション</v-chip>
              <v-chip v-if="sample.Opinion==true" label color="red" class="white--text mr-2 my-1">{{ getOpinionString(sample.Opinion )}}</v-chip>
              <v-chip v-if="sample.Filter!='001'" outlined label color="green darken-3" class="mr-2 my-1">{{ getFilterString(sample.Filter) }}</v-chip>
              <v-chip v-if="sample.Surplus!='0'"  outlined label color="green darken-3" class="mr-2 my-1">{{ getSurplusString(sample.Surplus) }}</v-chip>
            </v-card-title>


            <v-card-title class="pt-0 pb-0 mb-0">
              <v-chip small label color="gray" class="mr-2" style="width: 120px">分析料金</v-chip>
              <div>{{ Number(sample.Fee).toLocaleString() }} 円（税抜き）</div>
            </v-card-title>
            <v-card-text class="mt-3 ml-2">

          <v-row dense>
            <v-col cols="10" lg="8" md="10" sm='10' xs="10" dense class="pa-0">
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="SampleName"
                    :label="getItemName('サンプル名')[AnalizeTypeCategory+'label']"
                    :counter="getItemName('サンプル名')[AnalizeTypeCategory+'counter']"
                    @input="$v.SampleName.$touch()"
                    :error-messages="SampleNameErrors"
                    :messages="getItemName('サンプル名')[AnalizeTypeCategory+'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('サンプル名')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span>{{getItemName('サンプル名')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" lg="1" md='1' sm='1' xs="2" align-self="center" dense>
              <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
            </v-col>
          </v-row>
          
              <v-row dense>
                <v-col cols="10" md="3" class="align-end" dense> 
                  <v-text-field
                    v-model="OilmakerID"
                    :label="getItemName('使用オイルメーカー')[AnalizeTypeCategory+'label']"
                    counter=20
                    @input="$v.OilmakerID.$touch()"
                    @blur="$v.OilmakerID.$touch()"
                    :error-messages="OilmakerIDErrors"
                    :messages="getItemName('使用オイルメーカー')[AnalizeTypeCategory + 'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('使用オイルメーカー')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                  </v-text-field>
                </v-col>
                <v-col cols="1" lg="1" md='1' sm='2' xs="2" dense>
                </v-col>

                <v-col cols="10" md="3" class="align-end" dense> 
                  <v-tooltip top color="grey darken-2">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-on="on"
                        v-model="OilModelNumber"
                        :label="getItemName('使用オイル銘柄')[AnalizeTypeCategory+'label']"
                        :counter="getItemName('使用オイル銘柄')[AnalizeTypeCategory+'counter']"
                        @input="$v.OilModelNumber.$touch()"
                        @blur="$v.OilModelNumber.$touch()"
                        :error-messages="OilModelNumberErrors"
                        :messages="getItemName('使用オイル銘柄')[AnalizeTypeCategory + 'message']"
                      >
                        <template v-slot:prepend-inner v-if="getItemName('使用オイル銘柄')[AnalizeTypeCategory+'証明書']">
                          <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <span>{{getItemName('使用オイル銘柄')[AnalizeTypeCategory+'description']}}</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="1" lg="1" md='1' sm='2' xs="2" align-self="center" dense>
                  <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="6" xl="2" lg="3" md='4' sm='5' xs="6" class="align-end" dense>
                  <v-tooltip top color="grey darken-2">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-on="on"
                        v-model="OilUsageTime"
                        :label="getItemName('オイル使用時間')[AnalizeTypeCategory+'label']"
                        dense
                        @input="$v.OilUsageTime.$touch()"
                        :error-messages="OilUsageTimeErrors"
                        :messages="getItemName('オイル使用時間')[AnalizeTypeCategory + 'message']"
                      >
                        <template v-slot:prepend-inner v-if="getItemName('オイル使用時間')[AnalizeTypeCategory+'証明書']">
                          <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <span>{{getItemName('オイル使用時間')[AnalizeTypeCategory+'description']}}</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="4" xl="1" lg="2" md='2' sm='4' xs="4" dense>
                  <v-select
                    v-model="OilUsageTimeUnit"
                    label="単位"
                    dense
                    :items="useUnits"
                    item-value="Value"
                    item-text="Text"
                    clearable
                    @change="changeOilUsageTimeUnit()"
                  ></v-select>
                </v-col>
                <v-col cols="1"  lg="1" md='1' sm='2' xs="2" dense>
                </v-col>
                <v-col cols="5" md="3" class="align-end" dense> 
                </v-col>
              </v-row>

            <v-row dense>
              <v-col cols="8" lg="2" md="3" sm='4' xs="8" dense>
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="SamplingAt"
                      :label="getItemName('採取日')[AnalizeTypeCategory+'label']"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      @input="$v.SamplingAt.$touch()"
                      :error-messages="SamplingAtErrors"
                      :messages="getItemName('採取日')[AnalizeTypeCategory+'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('採取日')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="SamplingAt"
                    @input="menu2 = false"
                    locale="ja"
                  ></v-date-picker>
                  </v-menu>
              </v-col>
              <v-col cols="2" lg="1" md='1' sm='1' xs="2" align-self="center" dense>
                <template v-if="AnalizeTypeCategory=='一般'">
                  <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
                </template>
              </v-col>

              <v-col cols="8" lg="2" md="3" sm='4' xs="8" dense>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="BottleCount"
                      :label="getItemName('ボトル数')[AnalizeTypeCategory+'label']"
                      v-on="on"
                      @input="$v.BottleCount.$touch()"
                      :error-messages="BottleCountErrors"
                      :messages="getItemName('ボトル数')[AnalizeTypeCategory+'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('ボトル数')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <span>{{getItemName('ボトル数')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-col>
              <v-col cols="2" lg="1" md='1' sm='1' xs="2" align-self="center" dense>
                <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
              </v-col>
<!--
              <v-col cols="8" lg="2" md="3" sm='4' xs="8" dense>
                <v-menu
                  v-model="menu3"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="DeliveryPeriod"
                      label="指定納期"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="DeliveryPeriod"
                    @input="menu2 = false"
                    locale="ja"
                  ></v-date-picker>
                  </v-menu>
              </v-col>
-->
            </v-row>

            <template v-if="AnalizeTypeCategory=='航空機'">
              <v-row dense class="mb-2">
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <v-tooltip top color="grey darken-2">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-on="on"
                        v-model="SamplingBy"
                        :label="getItemName('採取者')[AnalizeTypeCategory+'label']"
                        :counter="getItemName('採取者')[AnalizeTypeCategory+'counter']"
                        @input="$v.SamplingBy.$touch()"
                        :error-messages="SamplingByErrors"
                        :messages="getItemName('採取者')[AnalizeTypeCategory+'message']"
                      >
                        <template v-slot:prepend-inner v-if="getItemName('採取者')[AnalizeTypeCategory+'証明書']">
                          <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <span>{{getItemName('採取者')[AnalizeTypeCategory+'description']}}</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="2" xl="1" lg="1" md='1' sm='1' xs="2" align-self="center" dense>
                </v-col>
              </v-row>

              <v-row dense class="mb-2">
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <v-tooltip top color="grey darken-2">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-on="on"
                        v-model="SamplingPlace"
                        :label="getItemName('サンプル採取場所')[AnalizeTypeCategory+'label']"
                        counter=12
                        @input="$v.SamplingPlace.$touch()"
                        :error-messages="SamplingPlaceErrors"
                        :messages="getItemName('サンプル採取場所')[AnalizeTypeCategory+'message']"
                      >
                        <template v-slot:prepend-inner v-if="getItemName('サンプル採取場所')[AnalizeTypeCategory+'証明書']">
                          <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <span>{{getItemName('サンプル採取場所')[AnalizeTypeCategory+'description']}}</span>
                  </v-tooltip>
                </v-col>
              </v-row>

              <v-row dense class="ml-4 mb-2">
                <v-col cols="12" lg="12" md="12" dense class="pa-0">
                  <v-checkbox
                    v-model="isOilChanged"
                    class="agree-text" 
                    dense
                    label="オイル交換情報を報告書に印字する"
                  ></v-checkbox>   
                  <template v-if="isOilChanged">
                    <v-row dense class="ml-6 mt-0">
                      <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                        <div class="subtitle-2 grey lighten-3 pl-2">
                          {{getItemName('オイル交換有無')[AnalizeTypeCategory+'label']}}
                        </div>
                      </v-col>
                      <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                        <div class="subtitle-2 grey lighten-3 pl-2">
                          {{getItemName('オイル交換有無')[AnalizeTypeCategory+'message']}}
                        </div>
                      </v-col>
                      <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                        <div class="body-1  font-weight-bold pl-2">
                          CHANGE
                        </div>
                      </v-col>

                      <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                        <div class="subtitle-2 grey lighten-3 pl-2">
                          {{getItemName('オイル交換量')[AnalizeTypeCategory+'label']}}
                        </div>
                      </v-col>
                      <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                        <div class="subtitle-2 grey lighten-3 pl-2">
                          {{getItemName('オイル交換量')[AnalizeTypeCategory+'message']}}
                        </div>
                      </v-col>
                      <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                        <div class="body-1  font-weight-bold pl-2">
                        {{OilChange}} {{OilChangeUnitText}}
                        </div>
                      </v-col>

                      <v-col cols="12" dense class="pa-0">
                        ※変更する場合はマイ機器のオイル交換情報を変更して下さい。
                      </v-col>

                    </v-row>
                  </template>
                </v-col>
              </v-row>
            </template>
            
            <v-row dense>
              <v-col cols="12" lg="12" md="12" dense>
                <span class="caption">サンプルメモ（ジャパン・アナリストへの伝達事項）</span>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-textarea
                      v-model="SampleMemo"
                      v-on="on"
                      dense
                      filled
                      counter=60
                      @input="$v.SampleMemo.$touch()"
                      :error-messages="SampleMemoErrors"
                    ></v-textarea>
                  </template>
                  <span>{{getItemName('サンプルメモ')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            outlined
            rounded
            elevation="2"
            @click="doEditSample = false"
          >
            キャンセル
          </v-btn>

          <v-tooltip top color="grey darken-2">
            <template v-slot:activator="{ on }">
              <v-btn
              v-on="on"
              rounded 
              color="amber darken-1" 
              @click="updateSample"
              >
                <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
                  サンプル情報を更新する
              </v-btn>
            </template>
            <span>サンプル情報を更新します</span>
          </v-tooltip>
        </v-card-actions>

        </v-card>
      </v-dialog>


    <v-dialog
      v-model="isConfirmed"
      persistent
      max-width="90%"
    >
      <v-card class="px-3 py-2">
        <v-card-title class="headline">
          <v-icon class="mr-1" color="primary" large>mdi-information-outline</v-icon>
            ご依頼内容をご確認ください
          </v-card-title>
        <v-card-text> 下記の申請内容をご確認のうえ「分析診断を依頼する」ボタンをクリックしてください</v-card-text>
          <v-card outlined flat class="mb-3">
            <div class="teal darken-1 pa-2 mb-1 white--text">案件の情報</div>
            <v-row dense class="pa-2">
<!--
              <v-col cols="12" md="9">
                <v-text-field v-model="ApplicationName" label="案件名" dense readonly></v-text-field>
              </v-col>
-->
              <v-col cols="12" md='3'>
                <v-text-field v-model="CustomerOrderNumber" label="お客様内注文番号" dense readonly></v-text-field>
              </v-col>
            </v-row>
          </v-card>

          <v-card outlined flat class="mb-3">
            <div class="teal darken-1 pa-2 mb-1 white--text">納品明細書の送付先</div>
            <v-row dense class="pa-2">
              <v-col cols="12"  lg="4" md='4' sm='4' xs="12">
                  <v-text-field v-model="PayCompany" label="会社名" dense readonly></v-text-field>
              </v-col>
              <v-col cols="12"  lg="4" md='4' sm='4' xs="12">                    
                  <v-text-field v-model="PayOffice" label="事業者名" dense readonly></v-text-field>                      
              </v-col>
              <v-col cols="12"  lg="4" md='4' sm='4' xs="12">                    
                  <v-text-field v-model="PayDept" label="部署名" dense readonly></v-text-field>
              </v-col>
            </v-row>
            <v-row dense class="pa-2">
              <v-col cols="12"  lg="1" md='1' sm='1' xs="3">
                  <v-text-field v-model="PayZip" label="郵便番号" dense readonly></v-text-field>
              </v-col>
              <v-col cols="12"  lg="7
              " md='5' sm='5' xs="9">
                  <v-text-field v-model="PayAddress" label="ご住所" dense readonly></v-text-field>                      
              </v-col>
              <v-col cols="12"  lg="2" md='3' sm='3' xs="6">
                  <v-text-field v-model="PayTel" label="お電話番号" dense readonly></v-text-field>
              </v-col>
              <v-col cols="12"  lg="2" md='3' sm='3' xs="6">
                  <v-text-field v-model="PayFAX" label="FAX番号" dense readonly></v-text-field>
              </v-col>
            </v-row>
            <v-row dense class="pa-2">
              <v-col cols="12"  lg="4" md='4' sm='4' xs="6">
                  <v-text-field v-model="PayPIC" label="ご担当者様名" dense readonly></v-text-field>                      
              </v-col>
              <v-col cols="12"  lg="4" md='4' sm='4' xs="6">
                  <v-text-field v-model="Payemail" label="メールアドレス" dense readonly></v-text-field>
              </v-col>
            </v-row>                  
          </v-card>

          <v-card outlined flat class="mb-3">
            <div class="teal darken-1 pa-2 mb-1 white--text">報告書の送付先</div>
            <v-row dense class="pa-2">
              <v-col cols="12"  lg="4" md='4' sm='4' xs="12">
                <v-text-field v-model="DelvCompany" label="会社名" readonly dense></v-text-field>
              </v-col>
              <v-col cols="12"  lg="4" md='4' sm='4' xs="12">
                <v-text-field v-model="DelvOffice" label="事業所名" readonly dense></v-text-field>
              </v-col>
              <v-col cols="12"  lg="4" md='4' sm='4' xs="12">
                <v-text-field v-model="DelvDept" label="部署名" readonly dense></v-text-field>
              </v-col>
            </v-row>
            <v-row dense class="pa-2">
              <v-col cols="1"  lg="1" md='1' sm='1' xs="4">
                <v-text-field v-model="DelvZip" label="郵便番号" readonly dense></v-text-field>
              </v-col>
              <v-col cols="11"  lg="7" md='7' sm='7' xs="8">
                <v-text-field v-model="DelvAddress" label="ご住所" readonly dense></v-text-field>
              </v-col>
              <v-col cols="12"  lg="2" md='2' sm='2' xs="12">
                <v-text-field v-model="DelvTel" label="お電話番号" readonly dense></v-text-field>
              </v-col>
              <v-col cols="12"  lg="2" md='2' sm='2' xs="12">
                <v-text-field v-model="DelvFAX" label="FAX番号" readonly dense></v-text-field>
              </v-col>
            </v-row>

            <v-row dense class="pa-2">
              <v-col cols="12"  lg="4" md='4' sm='4' xs="6">
                <v-text-field v-model="DelvPIC" label="ご担当者様" readonly dense></v-text-field>
              </v-col>
              <v-col cols="12"  lg="4" md='4' sm='4' xs="6">
                  <v-text-field v-model="Delvemail" label="メールアドレス" dense readonly></v-text-field>
              </v-col>
            </v-row>
          </v-card>

          <v-card outlined flat class="mb-3">
            <div class="teal darken-1 pa-2 mb-1 white--text">報告書の宛名</div>
            <v-row dense class="pa-2">
              <v-col cols="12"  lg="4" md='4' sm='4' xs="12">
                <v-text-field v-model="RepCompany" label="会社名" dense readonly></v-text-field>
              </v-col>
              <v-col cols="12"  lg="3" md='3' sm='3' xs="12">
                <v-text-field v-model="RepOffice" label="事業所名" dense readonly></v-text-field>
              </v-col>
              <v-col cols="12"  lg="3" md='3' sm='3' xs="12">
                <v-text-field v-model="RepDept" label="部署名" dense readonly></v-text-field>
              </v-col>
              <v-col cols="12"  lg="2" md='2' sm='2' xs="12">
                <v-text-field v-model="RepPIC" label="ご担当者様名" dense readonly></v-text-field>
              </v-col>
            </v-row>
          </v-card>
          



            <v-card outlined flat class="mb-3">
              <div class="teal darken-1 pa-2 mb-1 white--text">分析サンプル</div>
              <v-row>
                <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="body-2" width="30%">サンプル名</th>
                          <th class="body-2" width="20%">機器ID</th>
                          <th class="body-2">採取日</th>
                          <th class="body-2">ボトル数</th>
                          <th class="body-2">分析料金</th>
<!--
                          <th class="body-2">指定納期</th>
-->
                        </tr>
                      </thead>
                      <tbody>
                        <tr dense v-for="item of selectedSamples" v-bind:key="item.id">
                          <td class="body-1">
                            {{ item.Name}}
                          </td>
                          <td class="body-1">
                            {{ item.CustomerMachineID}}
                          </td>
                          <td class="body-1">
                              {{ item.SamplingAt}}
                          </td>
                          <td class="body-1">
                              {{ item.BottleCount}}
                          </td>
                          <td class="body-1">
<!--
                              &yen; {{ Number(item.Price).toLocaleString() }}
-->
                              &yen; {{ Number(item.Fee).toLocaleString() }}
                          </td>
<!--
                          <td class="body-1">
                              <span v-show="item.DeliveryPeriod">{{ item.DeliveryPeriod}}</span>
                              <span v-show="!item.DeliveryPeriod">指定無し</span>
                          </td>
-->
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
          </v-card>

        <v-card-actions>
          <div class="title">
            分析料金
<!--
            {{(TotalFee + SurplusFee - DiscountInfo.discount).toLocaleString()}} 円（税抜き）
-->
            {{(TotalFee + SurplusFee).toLocaleString()}} 円（税抜き）
          <div v-if="DiscountInfo.code" class="title red--text">
            Web割引
            - {{Number(DiscountInfo.discount).toLocaleString()}} 円
          </div>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            outlined
            rounded
            elevation="2"
            @click="isConfirmed = false"
          >
            キャンセル
          </v-btn>
          <v-tooltip top color="grey darken-2">
            <template v-slot:activator="{ on }">
              <v-btn 
              v-on="on"
              rounded 
              color="amber darken-1" 
              @click="createApplication()" 
              :disabled="processing"
              data-createApplication 
              class="px-2"
              >
                <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
                  分析診断を依頼する
              </v-btn> 
            </template>
            <span>依頼を登録します</span>
          </v-tooltip>


        </v-card-actions>
      </v-card>
    </v-dialog>

  <!-- dialogコール -->
  <app-dialog :failureUrl="failureUrl" :message="failuerMessage" :detail="failuerDetail" ref="isFailured"></app-dialog>
  <suc-dialog :successText="successText" :successUrl="successUrl" ref="isSuccessed"></suc-dialog>
  <vali-dialog :valiErrorText="valiErrorText" ref="isErrored"></vali-dialog>
  <loading-dialog :message="loadingMessage" :progressMessages="progressMessages" ref="isLoading"></loading-dialog>

    </v-container>
</template>

<script>
import { API, graphqlOperation} from "aws-amplify"
import { createApplication,  } from "../graphql/mutations"
import { updateApplication,  } from "../graphql/mutations"
import { updateSample } from "../graphql/mutations"
import { createSample } from "../graphql/mutations"
import { getSample } from '../graphql/queries'
import { samplesByOffice, samplesByApplication } from '../graphql/queries'
import { getApplication } from '../graphql/queries'
import { getMachine } from '../graphql/queries'
import validations from '../utils/validations.js'
import { numeric, required, maxLength } from 'vuelidate/lib/validators'
import { employeeByOffice } from '../graphql/queries'
import isFailured from "../components/failureDialog.vue"
import valiErrored from "../components/validateErrorDialog.vue"
import entSuccessed from "../components/successApplicationDialog.vue"
import Loading from "../components/Loading.vue"
import { helpers } from 'vuelidate/lib/validators'
const alpha_dash = helpers.regex('alpha_dash', /^[a-zA-Z0-9_ -]*$/)
import generateUuid  from '../utils/generateUuid.js'
import utilsMixin  from '../utils/mixin.js'
import utils  from '../utils/utils.js'
import logging  from '../utils/logging.js'

function requiredRepPICID (vaslue, vm) {
console.log("vm.CustomRepCheckbox", vm.CustomRepCheckbox)
console.log("vm.RepPICID", vm.RepPICID)
  if (!vm.CustomRepCheckbox) {
    if(!vm.RepPICID) {
      console.log("return", false)
      return false
    }
  }
    console.log("return", true)
  return true
}
function hasOilUsageTimeUnit (value, vm) {
  if (vm.OilUsageTime) {
    if(!vm.OilUsageTimeUnit) {
      return false
    }
  }
  return true
}
function requiredPromptFumei (value) {
  if (!value) {
    return false
  }
  return true
}

function requiredPromptFumeiEn (value) {
  if (!value) {
    return false
  }
  return true
}
function alphaNumPlus(value) {
  if(value) {
    // 半角英数（＋ハイフン、ドット、アンダースコア）のみ許可
    if(!value.match(/^[0-9a-zA-Z/.\s_-]*$/)){
        return false;
    }
  }
  return true
}

function useTime(value) {
  if(value) {
    let _value = String(value)
    if(!_value.match(/^([1-9]\d*|0)(\.\d{1})?$/)){
      if(_value.match(/^([0-9]\d*):([0-5][0-9])$/)){
        return true;
      }else {
        return false;
      }
    }
  }
  return true
}

export default {

  beforeRouteLeave (to, from, next) {
    if (this.$v.$anyDirty&&!this.isPageMove) {
      let answer = window.confirm("編集中のデータがあります。本当にこのページから離れますか？")
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
       next()
    }
  },

  mixins:[validations, generateUuid, utilsMixin, utils, logging],
  head: {
    title: { inner: '分析・診断サービス依頼'},
  },
  components: {
    sucDialog: entSuccessed,
    appDialog: isFailured,
    valiDialog: valiErrored,
    LoadingDialog: Loading,
  },  
  data() {
    return {
    e6: 1,
    AnalizeTypeCategory: "",
    applicationid: "",
    selectedSamples: [],
    agreement: false,
    ApplicationName: "",
    CustomerOrderNumber: "",

    Report: this.$store.state.operatingOffice.OfficeID,
    Delivery: this.$store.state.operatingOffice.OfficeID,
    Payment: this.$store.state.operatingOffice.OfficeID,
    DefaultPayment: this.$store.state.operatingOffice.PaymentOfficeID,
    isChangePayment: true,

    RepCompany: "",
    RepOffice: "",
    RepDept: "",
    RepPIC: "",
    RepEmployee: [],
    RepPICID: "",
    RepZip: "",
    RepAddress: "",
//    RepTel: "",
//    RepFAX: "",
//    Repemail: "",

    DelvCompany: "",
    DelvOffice: "",
    DelvZip: "",
    DelvAddress: "",
    DelvDept: "",
    DelvPIC: "",
    DelvTel: "",
    DelvFAX: "",
    Delvemail: "",
    DelvEmployee: [],
    DelvPICID: "",

    PayCompany: "",
    PayOffice: "",
    PayZip: "",
    PayAddress: "",
    PayDept: "",
    PayPIC: "",
    PayTel: "",
    PayFAX: "",
    Payemail: "",
    PayEmployee: [],
    PayPICID: "",

//    Shipping: "メールのみ",
//    shippingOptions: [
//      "メールのみ",
//      "郵送のみ",
//      "郵送＋メール",
//    ],

    Shipping: "ダウンロードのみ",
    shippingOptions: [
      "ダウンロードのみ",
      "郵送＋ダウンロード",
      "メール＋ダウンロード"
    ],

    menu2: false,
    menu3: false,

    CustomRepCheckbox: false,
    CustomRepDisabled: true,

    SameDeliveryAsOrderer: true,
//    SamePayAsDelivery: true,

    TotalPrice: 0,
    TotalFee: 0,
    DiscountInfo: {},
    SurplusFee:0,
    SurplusCount:0,

    search: '',
    isSelected: false,
    isDuplicate: false, // 依頼済みサンプルを選択している
    hasNoChecnSample: false, // 見積からの依頼でチェックされていない
    isMaxSamples: false, // 最大サンプル数を超えている
    maxSamples: 50,
    // isSuccessed: false,
    isConfirmed: false,
    // isErrored: false,
    isSampleNoukiDialog: false,
    isPageMove: false,
    isCreate: true,
    isQuote: false,
    processing: false,
    successUrl: '/',
    successText: 'ご依頼ありがとうございました。<br>分析サンプルと依頼書をジャパン・アナリストまでご送付ください。',
    valiErrorText: '申請内容に不備がございます<br>赤字のエラー箇所を修正ください</p>',
    failureUrl: '/',
    failuerMessage: "",
    failuerDetail: "",
    loadingMessage: "処理中です。しばらくこのままでお待ちください。",
    progressMessages: [{"status":0, "message":"分析依頼の仮登録"}, {"status":0, "message":"サンプルの登録"}, {"status":0, "message":"分析依頼の予約"}],
    page: 1,
    pageCount: 0,
    totalVisible: 7,
    itemsPerPage: 10,
    headers: [
        {
        text: 'サンプル識別名',
        align: 'start',
        sortable: false,
        value: 'Name',
        width: '25%',
        class: "grey darken-2 white--text",
        },
        {
        text: '機器ＩＤ',
        value: 'CustomerMachineID',
        width: '20%',
        class: "grey darken-2 white--text",
        },
        {
        text: '採取日',
        value: 'SamplingAt',
        class: "grey darken-2 white--text",
        },
        {
        text: 'ボトル数',
        value: 'BottleCount',
        class: "grey darken-2 white--text",
        },
        {
        text: '危険物',
        value: 'HazardousMaterialsConfirmed',
        class: "grey darken-2 white--text",
        },
        {
        text: '分析料金',
        value: 'Fee',
        class: "grey darken-2 white--text",
        },
/*
        {
        text: '指定納期',
        value: 'DeliveryPeriod',
        class: "grey darken-2 white--text",
        },
*/
    ],
    quoteSampleheaders: [
      {
        text: '',
        align: 'start',
        sortable: false,
        value: 'Checked',
        width: '3%',
        class: "grey darken-2 white--text",
      },
      {
        text: 'サンプル識別名',
        align: 'start',
        sortable: false,
        value: 'Name',
        width: '15%',
        class: "grey darken-2 white--text",
      },
      {
        text: 'マイ機器ＩＤ',
        sortable: false,
        value: 'CustomerMachineID',
        width: '10%',
        class: "grey darken-2 white--text",
      },
      {
        text: 'オイル種別',
        sortable: false,
        value: 'OilTypeCategoryText',
        width: '10%',
        class: "grey darken-2 white--text",
      },
      {
        text: '分析セット',
        sortable: false,
        value: 'AnalizeSetName',
        width: '15%',
        class: "grey darken-2 white--text",
      },
      {
        text: '個別分析項目',
        sortable: false,
        value: 'AnalizeItems',
        width: '5%',
        class: "grey darken-2 white--text",
      },
      {
        text: 'オイル名',
        sortable: false,
        value: 'OilModelNumber',
        width: '10%',
        class: "grey darken-2 white--text",
      },
      {
        text: 'オイル使用時間',
        sortable: false,
        value: 'OilUsageTime',
        width: '7%',
        class: "grey darken-2 white--text",
      },
      {
        text: '採取日',
        sortable: false,
        value: 'SamplingAt',
        width: '5%',
        class: "grey darken-2 white--text",
      },
      {
        text: 'ボトル数',
        sortable: false,
        value: 'BottleCount',
        width: '5%',
        class: "grey darken-2 white--text",
      },
      {
        text: '危険物',
        sortable: false,
        value: 'HazardousMaterialsConfirmed',
        width: '5%',
        class: "grey darken-2 white--text",
      },
      {
        text: '分析料金',
        sortable: false,
        value: 'Fee',
        width: '5%',
        class: "grey darken-2 white--text",
      },
/*
      {
        text: '指定納期',
        sortable: false,
        value: 'DeliveryPeriod',
        width: '5%',
        class: "grey darken-2 white--text",
      },
*/
    ],
    doEditSample: false,
    editSampleID: "",
    sample: {},
    checked: 0,
      
    SampleName: "",
    OilmakerID: "",
    OilModelNumber: "",
    OilUsageTime: "",
    OilUsageTimeUnit: "",
    OilUsageTimeUnitText: "",
    SamplingAt: "",
    BottleCount: "",
    SampleMemo: "",
    DeliveryPeriod: "",

    SamplingBy: "",
    SamplingPlace: "",
    isOilChanged: false,
    OilChange: "",
    OilChangeUnit: "",
    OilChangeUnitText: "",

    samples: [],

    editedIndex: -1,
    editedItem: {
      DeliveryPeriod: '',
    },      
//    agreement_url: process.env.VUE_APP_AGREE_URL,
    agreement_url: "https://www.japan-analysts.com/downloads/terms/"
    }
  },
  validations() {
    let _validations = {
      ApplicationName: { maxLength: maxLength(80) },
      CustomerOrderNumber: { alpha_dash, maxLength: maxLength(20) },
      selectedSamples: { required },
      RepCompany: { required, maxLength: maxLength(30) },
      RepOffice: { maxLength: maxLength(30) },
      RepDept: { maxLength: maxLength(30) },
      RepPIC: { required, maxLength: maxLength(30) },

      RepPICID: { requiredRepPICID },
      DelvPICID: { required },
//      PayPICID: { required // 請求先担当者は任意とする

//    SampleName: { required, maxLength: maxLength(50) },
      OilUsageTime: { useTime, hasOilUsageTimeUnit },
//      OilmakerID: { requiredPromptFumei, maxLength: maxLength(20)  },
//      OilModelNumber: { requiredPromptFumei, maxLength: maxLength(78) },
      BottleCount: { numeric, required },
      SampleMemo: { maxLength: maxLength(60) },
    }
    if (this.AnalizeTypeCategory == '一般') {
      _validations["SampleName"] = { required, maxLength: maxLength(20) }
      _validations["SamplingBy"] = { }
      _validations["SamplingPlace"] = { }
      _validations["OilmakerID"] = { maxLength: maxLength(20) },
      _validations["OilModelNumber"] = { requiredPromptFumei, maxLength: maxLength(20) }
      _validations["SamplingAt"] = { required }

    }else {
      _validations["SampleName"] = { required, alphaNumPlus, maxLength: maxLength(15) }
      _validations["SamplingBy"] = { alphaNumPlus, maxLength: maxLength(12) }
      _validations["SamplingPlace"] = { alphaNumPlus, maxLength: maxLength(12) }
      _validations["OilmakerID"] = { alphaNumPlus, maxLength: maxLength(20)  },
      _validations["OilModelNumber"] = { requiredPromptFumeiEn, alphaNumPlus, maxLength: maxLength(15) }
      _validations["SamplingAt"] = { }
    }
    return _validations
  },
  filters: {
    addComma: function (value) {
      return value.toLocaleString();
    }
  },
  computed: {
    officeList () {
      return this.$store.state.officeList
    },
    useUnits () {
      return this.$store.state.useUnits
    },
    isRepDisable() {
//      if((!this.SameDeliveryAsOrderer) && (!this.CustomRepCheckbox)) { // 2025 報告書宛名と連動しない
      if(!this.SameDeliveryAsOrderer) {
        return false
      } else {
        return true
      }
    },
    returnPath() {
      if(this.isQuote) {
        return { path: '/quotesheet', query: {id: this.applicationid}}
      }else {
        return { path: '/' }
      }
    },

    RepCompanyErrors () { return this.defaultMessage(this.$v.RepCompany) },
    RepOfficeErrors () { return this.defaultMessage(this.$v.RepOffice) },
    RepDeptErrors () { return this.defaultMessage(this.$v.RepDept) },
    RepPICErrors () { return this.defaultMessage(this.$v.RepPIC) },
    RepPICIDErrors () { return this.defaultMessage(this.$v.RepPICID) },
    DelvPICIDErrors () { return this.defaultMessage(this.$v.DelvPICID) },
//    PayPICIDErrors () { return this.defaultMessage(this.$v.PayPICID) },

    ApplicationNameErrors () { return this.defaultMessage(this.$v.ApplicationName) },
    CustomerOrderNumberErrors () { return this.defaultMessage(this.$v.CustomerOrderNumber) },
    selectedSampleErrors () { return this.defaultMessage(this.$v.selectedSamples) },
    
    SampleNameErrors () { return this.defaultMessage(this.$v.SampleName) },
    OilUsageTimeErrors () { return this.defaultMessage(this.$v.OilUsageTime) },
    OilmakerIDErrors () { return this.defaultMessage(this.$v.OilmakerID) },
    OilModelNumberErrors () { return this.defaultMessage(this.$v.OilModelNumber) },
    SamplingAtErrors () { return this.defaultMessage(this.$v.SamplingAt) },
    BottleCountErrors () { return this.defaultMessage(this.$v.BottleCount) },
    SampleMemoErrors () { return this.defaultMessage(this.$v.SampleMemo) },

    SamplingByErrors () { return this.defaultMessage(this.$v.SamplingBy) },
    SamplingPlaceErrors () { return this.defaultMessage(this.$v.SamplingPlace) },
  },
  mounted: async function () {
    console.log("Application mouted")
    this.initialize()
  },
  methods: {
    initialize: async function() {
      // 新規依頼か見積もり依頼か判定
      // 新規依頼の場合
      if (this.$route.query.id == undefined){
        this.isCreate = true
        this.AnalizeTypeCategory = this.$route.query.category
        let analizeType = "1"
        if(this.AnalizeTypeCategory == "一般") {
          analizeType = "1"
        }else {
          analizeType = "2"
        }
        let sampleFilter = {
          and: [
            { AnalizeType:{ beginsWith: analizeType } },
            { Status:{ eq:"10000000" } }
          ]
        }
        let samples = await API.graphql(graphqlOperation(samplesByOffice, {limit: 999, OfficeID: this.$store.state.operatingOffice.OfficeID + "-00000000", filter: sampleFilter}))
        console.log("unapply samples:", samples)
        //サンプル登録順にソート
        let _samples = samples.data.samplesByOffice.items;
        _samples.sort(function(a,b){
            if(a.createdAt < b.createdAt) return -1;
            if(a.createdAt > b.createdAt) return 1;
            return 0;
        });
        this.samples = _samples

        this.Report = this.$store.state.operatingOffice.OfficeID
        this.changeReport()
        this.Delivery = this.$store.state.operatingOffice.OfficeID
        this.changeDelivery()

        // 納品明細書送付先の初期値
        // 得意先の請求担当が登録されている場合は、得意先の請求担当をデフォルト
        // 得意先の請求担当が登録されていない場合は、依頼者
          console.log("デフォルト請求先事業所", this.DefaultPayment)
        if(this.DefaultPayment !== "" && this.DefaultPayment !== undefined && this.DefaultPayment !== null) {
          this.Payment = this.DefaultPayment
          this.isChangePayment = false
          console.log("デフォルト請求先を設定", this.Payment)
        }else {
          this.Payment = this.$store.state.operatingOffice.OfficeID
        }
        this.changePayment()
        return
      // 見積もり依頼の場合
      }else {
        this.applicationid = this.$route.query.id
        let application = await API.graphql(graphqlOperation(getApplication, {id: this.applicationid}))
        this.application = application.data.getApplication
        if(this.application.Type == "Quote") {
          this.isCreate = true
          this.isQuote = true
        }else {
          this.isCreate = false
          this.isQuote = false
        }
        console.log("application", this.application)
        this.AnalizeTypeCategory = this.getApplicationAnalizeTypeCategory(this.application)
        
        // samplesByApplicationを使用してサンプルを取得
        let samples = await API.graphql(graphqlOperation(samplesByApplication, {ApplicationID: this.applicationid, limit: 999}))
        //サンプルIDでソート
        let _samples = samples.data.samplesByApplication.items
        _samples.sort(function(a,b){
            if(a.SampleID < b.SampleID) return -1;
            if(a.SampleID > b.SampleID) return 1;
            return 0;
        });

        // 見積からの分析依頼の場合、サンプル数（同一サンプルの依頼数）分複製
        // 見積のレコードは、サンプル数に数字（1～）が入っている。（1レコード）
        // 依頼は同一内容で複数レコードで登録する
        if(this.isQuote) {
          let _samples2 = []
          for (const sample of _samples) {
            console.log(sample.id, sample.SameCount)
            for(let i=0; i < sample.SameCount; i++){
              let sample2 = JSON.parse(JSON.stringify(sample));
              let uuid = this.generateUuid("xxxx-xxxx-4xxx-yxxx")
              sample2.id = uuid
              sample2.SameCount = 1
              sample2.AnalizeItems = JSON.parse(sample2.AnalizeItems)
              sample2.AnalizeItemNames = JSON.parse(sample2.AnalizeItemNames)
              _samples2.push(sample2)
            }
          }
          this.selectedSamples = _samples2
          console.log("this.selectedSamples", this.selectedSamples)

          // サンプル返却手数料
          if(this.application.hasSurplus == "true") {
            this.SurplusFee = 1800
            this.SurplusCount = 1 //とりあえず1以上であればいいので1
          }
        }else {
          this.selectedSamples = _samples
        }

        this.Report = this.$store.state.operatingOffice.OfficeID
        this.changeReport()
        this.Delivery = this.$store.state.operatingOffice.OfficeID
        this.changeDelivery()

        // 納品明細書送付先の初期値
        // 得意先の請求担当が登録されている場合は、得意先の請求担当をデフォルト
        // 得意先の請求担当が登録されていない場合は、依頼者
        console.log("見積もり デフォルト請求先事業所", this.DefaultPayment)
        console.log("見積もり 処理中事業所 請求先事業所", this.$store.state.operatingOffice.PaymentOfficeID)
        if(this.DefaultPayment !== "" && this.DefaultPayment !== undefined && this.DefaultPayment !== null) {
          this.Payment = this.DefaultPayment
          this.isChangePayment = false
          console.log("見積もり デフォルト請求先を設定", this.Payment)
        }else {
          this.Payment = this.$store.state.operatingOffice.OfficeID
        }
//        this.Payment = this.$store.state.operatingOffice.OfficeID
        this.changePayment()
      }
    },

    editSample: async function(sample) {
      console.log("input sample is ", sample)

      this.editSampleID = sample.id
      this.sample = sample

      this.SampleName = sample.Name
      this.OilmakerID = sample.OilmakerID
      this.OilModelNumber = sample.OilModelNumber
      this.OilUsageTime = sample.OilUsageTime
      this.OilUsageTimeUnit = sample.OilUsageTimeUnit
      this.OilUsageTimeUnitText = sample.OilUsageTimeUnitText
      this.SamplingAt = sample.SamplingAt
      this.BottleCount = sample.BottleCount
      this.SampleMemo = sample.Memo
      this.DeliveryPeriod = sample.DeliveryPeriod
      this.SamplingBy = sample.SamplingBy
      this.SamplingPlace = sample.SamplingPlace

      this.doEditSample = true

      if(sample.MachineID) {
        let _machine = await API.graphql(graphqlOperation(getMachine, {id: sample.MachineID}))
        let machine = _machine.data.getMachine
        if(machine) {
          this.SamplingPlace = machine.SamplingPlace
          this.SamplingBy = machine.SamplingBy
          this.OilUsageTime = machine.OilUsageTime
          this.OilUsageTimeUnit = machine.OilUsageTimeUnit
          this.OilUsageTimeUnitText = machine.OilUsageTimeUnitText
        }
      }

      // バリデーションエラーをリセット
			this.$nextTick(() => { this.$v.$reset() })

    },
    updateSample: function() {
      console.log("updateSample", this.editSampleID)
      let valid = this.validationUpdateSample(2)
      if(valid != 2) {
        return
      }

      this.sample.Name = this.SampleName
      this.sample.OilmakerID = this.OilmakerID
      this.sample.OilModelNumber = this.OilModelNumber
      this.sample.OilUsageTime = this.OilUsageTime
      this.sample.OilUsageTimeUnit = this.OilUsageTimeUnit
      this.sample.OilUsageTimeUnitText = this.OilUsageTimeUnitText
      this.sample.SamplingAt = this.SamplingAt
      this.sample.BottleCount = this.BottleCount
      this.sample.Memo = this.SampleMemo
      this.sample.DeliveryPeriod = this.DeliveryPeriod

      if(!this.sample.Checked) {
        this.sample.Checked = true
        this.checked ++
        this.TotalPrice = this.TotalPrice + Number(this.sample.Price)
        this.TotalFee = this.TotalFee + Number(this.sample.Fee)
      }

      this.doEditSample = false
    },
    openAgreement() {
        window.open(this.agreement_url, '_blank')
    },
    changeStepper: function(step) {
      let nextstep = this.validation(step)
      console.log("next step", nextstep)
      this.e6 = nextstep
    },
    validationUpdateSample: function(step) {
      console.log("validationUpdateSample", step)
      console.log("SamplingBy", this.SamplingBy)
      console.log("SamplingPlace", this.SamplingPlace)
      if(step >= 2) {
        this.$v.SampleName.$touch()
        this.$v.OilmakerID.$touch()
        this.$v.OilModelNumber.$touch()
        this.$v.OilUsageTime.$touch()
        this.$v.SamplingAt.$touch()
        this.$v.SamplingBy.$touch()
        this.$v.SamplingPlace.$touch()
        this.$v.BottleCount.$touch()
        this.$v.SampleMemo.$touch()
        if (this.$v.SampleName.$invalid ||
            this.$v.OilmakerID.$invalid ||
            this.$v.OilModelNumber.$invalid ||
            this.$v.OilUsageTime.$invalid ||
            this.$v.SamplingAt.$invalid ||
            this.$v.SamplingBy.$invalid ||
            this.$v.SamplingPlace.$invalid ||
            this.$v.BottleCount.$invalid ||
            this.$v.SampleMemo.$invalid
        ) {
          return 1
        }
      }
      return step
    },
    validationApplication: async function() {
      let step = this.validation(7)
      if(step != 7) {
        this.e6 = step
        return
      }

      // Web割引情報を取得
//      if(!this.isQuote) {
        if(this.isDiscountCompany()){ 
          this.DiscountInfo = await this.getDiscount(this.TotalFee + this.SurplusFee)
        }
        console.log("analize fee discountInfo", this.DiscountInfo)
//      }

      this.isConfirmed = true
    },
    validation: function(step) {
      console.log("validation", step)
      if(step >= 2) {
        this.$v.ApplicationName.$touch()
        this.$v.CustomerOrderNumber.$touch()
        if (this.$v.ApplicationName.$invalid ||
            this.$v.CustomerOrderNumber.$invalid
        ) {
          this.$refs.isErrored.open();
          this.isErrored = true
          this.processing = false
          return 1
        }
      }
      if(step >= 4) {
        this.$v.DelvPICID.$touch()
        if (this.$v.DelvPICID.$invalid
        ) {
          this.$refs.isErrored.open();
          this.isErrored = true
          this.processing = false
          return 3
        }
      }
      if(step >= 5) {
        this.$v.RepCompany.$touch()
        this.$v.RepOffice.$touch()
        this.$v.RepDept.$touch()
        this.$v.RepPIC.$touch()
        if (this.$v.RepCompany.$invalid ||
            this.$v.RepOffice.$invalid ||
            this.$v.RepDept.$invalid ||
            this.$v.RepPIC.$invalid
        ) {
          this.$refs.isErrored.open();
          this.isErrored = true
          this.processing = false
          return 4

        }
      }
/*
      if(step >= 5) {
        this.$v.PayPICID.$touch()
        if (this.$v.PayPICID.$invalid
        ) {
          this.$refs.isErrored.open();
          this.isErrored = true
          this.processing = false
          return 4
        }
      }
*/
      if(step >= 6) {
         if (this.$v.selectedSamples.$invalid ){
          this.isSelected = true
          this.$refs.isErrored.open();          
          this.processing = false
          return 5
        }

        if(this.isQuote == false) {
          if(this.selectedSamples.length > this.maxSamples) {
            console.log("最大サンプル数超過")
            this.isMaxSamples = true
            this.$refs.isErrored.open();          
            this.processing = false
            this.e6 = 5
          }

          // TODO 非同期になってしまうのでe6を直接更新
          for (const item of this.selectedSamples) {
            this.sampleid = item.id
            API.graphql(graphqlOperation(getSample, {id: this.sampleid})
            ).then(({ data: { getSample } }) => {
              const sample = getSample
              // すでに依頼済みのサンプルはNG
              if( (sample.ApplicationID != undefined) && (sample.ApplicationID != "00000000")) {
                console.log("依頼済みサンプル", sample.id)
                this.isDuplicate = true
                this.$refs.isErrored.open();          
                this.processing = false
                this.e6 = 5
              }
            })
          }
        }else {
          if(this.selectedSamples.length > this.checked) {
            console.log("未確認サンプルあり", this.checked + "/" + this.selectedSamples.length)
            this.hasNoChecnSample = true
            this.$refs.isErrored.open();          
            this.processing = false
            return 5
          }
        }

      }
      console.log("valid", step)
      return step
    },

    
    createApplication: async function () {
      this.isConfirmed = false
      this.processing = true

      let valid = this.validation(7)
      if(valid != 7) {
        return
      }
      this.$refs.isLoading.start();

      //Application.idの値を自己生成 形式は4×4
      let uuid = this.generateUuid("xxxx-xxxx-4xxx-yxxx")
      console.log('this.PayPIC', this.PayPIC)

      const application = {
          id: uuid,
          OfficeID: this.$store.state.operatingOffice.OfficeID,
          Name: this.ApplicationName,
          AnalizeTypeCategory: this.AnalizeTypeCategory,
          RepCompanyID: this.Report.substr(0, 10),
          RepOfficeID: this.Report.substr(10, 5),
          RepCompany: this.RepCompany,
          RepOffice: this.RepOffice,
          RepDept: this.RepDept,
          RepPIC: this.RepPIC,
          RepEmployeeID: this.RepPICID.substr(15, 10),

          DelvCompanyID: this.Delivery.substr(0, 10),
          DelvOfficeID: this.Delivery.substr(10, 5),
          DelvCompany: this.DelvCompany,
          DelvOffice: this.DelvOffice,
          DelvDept: this.DelvDept,
          DelvPIC: this.DelvPIC,
          DelvType: this.DelvType,
          DelvEmployeeID: this.DelvPICID.substr(15, 10),

          Observation: this.Observation,

          PayCompanyID: this.Payment.substr(0, 10),
          PayOfficeID: this.Payment.substr(10, 5),
          PayCompany: this.PayCompany,
          PayOffice: this.PayOffice,
          PayDept: this.PayDept,
          PayPIC: this.PayPIC,
          PayEmployeeID: this.PayPICID.substr(15, 10),

          SampleCount: this.selectedSamples.length,
          Price: this.TotalPrice,
          Fee: this.TotalFee,
          Discount: JSON.stringify(this.DiscountInfo),
          Status: "Temp",

          OrdererID: this.$store.state.employee.EmployeeID,
          OrdererCompanyName: this.$store.state.employee.CompanyName,
          OrdererOfficeName: this.$store.state.employee.OfficeName,
          OrdererName: this.$store.state.employee.Name,
          CustomerOrderNumber: this.CustomerOrderNumber,
          sortKey: new Date().toISOString(),
          Type: "Application"
      }

      application["Shipping"] = this.Shipping

      //報告書宛名が自由入力かマスタ参照か
      if( this.CustomRepCheckbox == true ) {
        application["CustomRepName"] = "01"
      }else {
        application["CustomRepName"] = "00"
      }

      // 見積からの分析依頼の場合、見積番号（見積のid）を設定
      if(this.isQuote) {
          application.QuoteNumber = this.application.id
      }

      try {
          const registeredApplication = await API.graphql(graphqlOperation(createApplication, {input: application}))
          console.log('success', registeredApplication)

          this.progressMessages.splice( 0, 1, {"status":1, "message":"分析依頼の仮登録完了"});

          let applicationDialogIF = {}
          applicationDialogIF["id"] = uuid
          applicationDialogIF["hasHazardousMaterials"] = false
          applicationDialogIF["analizeTypeCategory"] = this.AnalizeTypeCategory

          console.log("this.selectedSamples", this.selectedSamples)

          let sampleid = 1;
          let surplusCount = 0;
          for (const item of this.selectedSamples) {
            // サンプル返却希望数カウント
            if (item.Surplus == "1" ) {
              surplusCount++
            }
            if(!this.isQuote) {
              const sample = {
                  id: item.id,
                  ApplicationID: registeredApplication.data.createApplication.id,
                  OfficeID: this.$store.state.operatingOffice.OfficeID,
                  DeliveryPeriod: item.DeliveryPeriod,
                  SampleID: ('0000000000' + sampleid).slice(-8)
              }
              const updatedSample = await API.graphql(graphqlOperation(updateSample, {input: sample}))
              console.log('success', updatedSample)
              sampleid = sampleid + 1
              if(item.isHazardousMaterials == "1") {
                applicationDialogIF["hasHazardousMaterials"] = true
              }
            }else {
              const sample = {
                id: item.id,
                SamplingAt: item.SamplingAt,
                SamplerName: item.SamplerName,
                MachineID: item.MachineID,
                Name: item.Name,
                AnalizeTypeGroup: item.AnalizeTypeGroup,
                AnalizeTypeGroupName: item.AnalizeTypeGroupName,
                CustomerName: item.CustomerName,
                CustomerMachineID: item.CustomerMachineID,
                MachineCategory: item.MachineCategory,
                MachineCategoryText: item.MachineCategoryText,
                MachineType: item.MachineType,
                MachineTypeText: item.MachineTypeText,
                Equipment: item.Equipment,
                MakerID: item.MakerID,
                MakerText: item.MakerText,
                ModelNumber: item.ModelNumber,
                PurchasedDate: item.PurchasedDate,
                SystemOil: item.SystemOil,
                SystemOilUnit: item.SystemOilUnit,
                SystemOilUnitText: item.SystemOilUnitText,
                MachineMemo: item.MachineMemo,
                TotalOperatingTime: item.TotalOperatingTime,
                TotalOperatingTimeUnit: item.TotalOperatingTimeUnit,
                TotalOperatingTimeUnitText: item.TotalOperatingTimeUnitText,
                OperatingTime: item.OperatingTime,
                OperatingTimeUnit: item.OperatingTimeUnit,
                OperatingTimeUnitText: item.OperatingTimeUnitText,
                OverhaulDate: item.OverhaulDate,
                SinceOverhaulTime: item.SinceOverhaulTime,
                SinceOverhaulTimeUnit: item.SinceOverhaulTimeUnit,
                SinceOverhaulTimeUnitText: item.SinceOverhaulTimeUnitText,
                ParentCustomerMachineID: item.ParentCustomerMachineID,
                ParentEquipment: item.ParentEquipment,
                ParentMakerID: item.ParentMakerID,
                ParentMakerText: item.ParentMakerText,
                ParentModelNumber: item.ParentModelNumber,
                ParentPurchasedDate: item.ParentPurchasedDate,
                ParentTotalOperatingTime: item.ParentTotalOperatingTime,
                ParentTotalOperatingTimeUnit: item.ParentTotalOperatingTimeUnit,
                ParentTotalOperatingTimeUnitText: item.ParentTotalOperatingTimeUnitText,
                ParentSinceOverhaulTime: item.ParentSinceOverhaulTime,
                ParentSinceOverhaulTimeUnit: item.ParentSinceOverhaulTimeUnit,
                ParentSinceOverhaulTimeUnitText: item.ParentSinceOverhaulTimeUnitText,
                OilmakerID: item.OilmakerID,
                OilmakerText: item.OilmakerText,
                OilModelNumber: item.OilModelNumber,
                OilGrade: item.OilGrade,
                OilGradeText: item.OilGradeText,
                OilTypeCategory: item.OilTypeCategory,
                OilTypeCategoryText: item.OilTypeCategoryText,
                OilType: item.OilType,
                OilTypeText: item.OilTypeText,
                OilProperty: item.OilProperty,
                OilPropertyText: item.OilPropertyText,
                isHazardousMaterials: item.isHazardousMaterials,
                HazardousMaterialsDetail: item.HazardousMaterialsDetail,
                HazardousMaterialsConfirmed: item.HazardousMaterialsConfirmed,
                TrackingNumber: item.TrackingNumber,
                OilChangeDate: item.OilChangeDate,
                isOilChange: item.isOilChange,
                OilChange: item.OilChange,
                OilChangeUnit: item.OilChangeUnit,
                OilChangeUnitText: item.OilChangeUnitText,
                OilUsageTime: item.OilUsageTime,
                OilUsageTimeUnit: item.OilUsageTimeUnit,
                OilUsageTimeUnitText: item.OilUsageTimeUnitText,
                UseFilter: item.UseFilter,
                FilterUsageTime: item.FilterUsageTime,
                FilterUsageTimeUnit: item.FilterUsageTimeUnit,
                FilterUsageTimeUnitText: item.FilterUsageTimeUnitText,
                OilCondition: item.OilCondition,
                OilConditionText: item.OilConditionText,
                AnalizeType: item.AnalizeType,
                AnalizeTypeName: item.AnalizeTypeName,
                AnalizeSet: item.AnalizeSet,
                AnalizeSetName: item.AnalizeSetName,
                AnalizeItems: JSON.stringify(item.AnalizeItems),
                AnalizeItemSub: item.AnalizeItemSub,
                AnalizePurpose: item.AnalizePurpose,
                StandardValue: item.StandardValue,
                StandardValueName: item.StandardValueName,
                Surplus: item.Surplus,
                Filter: item.Filter,
                LatestOrderNumber: item.LatestOrderNumber,
                OfficeID: this.$store.state.operatingOffice.OfficeID,
                BottleCount: item.BottleCount,
                ApplicationID: registeredApplication.data.createApplication.id,
                Status: item.Status,
                Memo: item.Memo,
                SamplingBy: item.SamplingBy,
                SamplingPlace: item.SamplingPlace,
                MountPosition: item.MountPosition,
                DeliveryPeriod: item.DeliveryPeriod,
                Quantity: item.Quantity,
                Price: item.Price,
                Report: item.Report,
                Opinion: item.Opinion,
                SampleID: ('0000000000' + sampleid).slice(-8),
                SameCount: item.SameCount,
                Message: item.Message,
                Discount: item.Discount,
                Tax: item.Tax,
                Fee: item.Fee,
                SampleNumber: item.SampleNumber
              }
              const createdSample = await API.graphql(graphqlOperation(createSample, {input: sample}))
              console.log('success', createdSample)
              sampleid = sampleid + 1

            }
          }
          this.progressMessages.splice( 1, 1, {"status":1, "message":"サンプルの登録完了（" + this.selectedSamples.length + "サンプル）"});

          // サンプルの登録ができたらステータス更新（バックエンド処理で連携）
          let _application = {
              id: registeredApplication.data.createApplication.id,
              Status: "Received",
          }
          // サンプル返却を希望するサンプルがひとつ以上あった場合
          if(surplusCount > 0) {
            _application["hasSurplus"] = true
          }else {
            _application["hasSurplus"] = false
          }

          await API.graphql(graphqlOperation(updateApplication, {input: _application}))
          this.progressMessages.splice( 2, 1, {"status":1, "message":"分析依頼の予約完了"});

          // お見積りからの依頼の場合、お見積りのステータスを更新
          if(this.isQuote) {
            const _quote = {
                id: this.application.id,
                Status: "quoteApplied",
            }
            await API.graphql(graphqlOperation(updateApplication, {input: _quote}))
            this.progressMessages.push( {"status":1, "message":"お見積りの状態更新"});
          }

          window.removeEventListener("beforeunload", this.handler)
          this.isPageMove=true
          this.$refs.isLoading.end();
          this.$refs.isSuccessed.open(applicationDialogIF);
      } catch (error) {
          console.log('error: ', error)
          await this.logging("ERROR", this.$store.state.operatingOffice.OfficeID, "create application error", error)
          this.failuerMessage = "分析依頼登録エラー"
          this.failuerDetail = error
          this.processing = false
          this.$refs.isLoading.end();
          this.$refs.isFailured.open();
      }
    },
    // 報告書の宛名を変更する クリック
    clickCustomRepCheckbox: async function() {
      if(this.CustomRepCheckbox) {
        this.CustomRepDisabled = false
      }else {
        // チェックされていない場合は報告書送付先と同じ情報をセット
        this.CustomRepDisabled = true
        const Office = this.officeList.filter(item => item.OfficeID  == this.Delivery)
        this.RepCompany = Office[0].CompanyName
        this.RepOffice = Office[0].Name
        this.RepDept = this.DelvDept
        this.RepPIC = this.DelvPIC
        this.RepZip = Office[0].Zip
        this.RepAddress = Office[0].Address1 + " " +Office[0].Address2+ " " +Office[0].Address3
        this.RepPICID = this.DelvPICID
        this.changeRepEmployee()
      }
    },

    // 報告書送付先 依頼者と同じクリック
    clickSameDeliveryAsOrderer: async function() {
      if(this.SameDeliveryAsOrderer) {
        this.Delivery = this.$store.state.operatingOffice.OfficeID
        await this.changeDelivery()
        this.DelvPICID = this.$store.state.employee.EmployeeID
        this.changeDelvEmployee()
//        this.CustomRepCheckbox = false // 2025 送付先と宛先は連動させない
//        this.CustomRepDisabled = true // 2025 送付先と宛先は連動させない
      }
      // チェックされていない場合はそのまま（なにもしない）
    },
/* 2025/10/30 いらない処理？
    clickSamePayAsDelivery: async function() {
      if(this.SamePayAsDelivery) {
        this.Delivery = this.Payment
        await this.changeDelivery()
        this.DelvPICID = this.PayPICID
        this.changeDelvEmployee()
      }
    },
*/
    changeDelivery: async function () {
        const Office = this.officeList.filter(item => item.OfficeID  == this.Delivery)
        this.DelvCompany = Office[0].CompanyName
        this.DelvOffice = Office[0].Name
        this.DelvZip = Office[0].Zip
        this.DelvAddress = Office[0].Address1 + " " +Office[0].Address2+ " " +Office[0].Address3
//        this.DelvDept = Office[0].PICDept
//        this.DelvPIC = Office[0].PIC
        this.DelvTel = Office[0].Tel
        this.DelvFAX = Office[0].FAX
//        this.Delvemail = Office[0].PICemail

        let employee = await API.graphql(graphqlOperation(employeeByOffice, {OfficeID: this.Delivery, limit: 999}))
        let _DelvEmployee = employee.data.employeeByOffice.items

        // WEBの利用許可済みの担当者情報のみに絞り込み
        this.DelvEmployee = _DelvEmployee.filter(function(item, index){ // eslint-disable-line no-unused-vars
          if (!item.Permission.startsWith('0')) return true;
        });

        // 自事業所に切り替わった場合は自分
        if(this.Delivery == this.$store.state.myoffice.OfficeID) {
          this.DelvPICID = this.$store.state.employee.EmployeeID
        }else {
          const _DelvPIC = this.DelvEmployee.filter(item => item.EmployeeID == Office[0].PICID)
          // 他事業所に切り替わった場合は、事業所の担当者IDがある場合はその担当者を選択
          if(_DelvPIC[0]) {
            this.DelvPICID = _DelvPIC[0].EmployeeID
          // それ以外の場合は担当者未選択
          }else {
            this.DelvPICID = ""
          }
        }
        this.changeDelvEmployee()
    },

    changeReport: async function () {
        const Office = this.officeList.filter(item => item.OfficeID  == this.Report)
        this.RepCompany = Office[0].CompanyName
        this.RepOffice = Office[0].Name
        this.RepDept = Office[0].PICDept
        this.RepPIC = Office[0].PIC
        this.RepZip = Office[0].Zip
        this.RepAddress = Office[0].Address1 + " " +Office[0].Address2+ " " +Office[0].Address3


        let employee = await API.graphql(graphqlOperation(employeeByOffice, {OfficeID: this.Report, limit: 999}))
        let _RepEmployee = employee.data.employeeByOffice.items

        // WEBの利用許可済みの担当者情報のみに絞り込み
        this.RepEmployee = _RepEmployee.filter(function(item, index){ // eslint-disable-line no-unused-vars
          if (!item.Permission.startsWith('0')) return true;
        });

        const _RepPIC = this.DelvEmployee.filter(item => item.EmployeeID == Office[0].PICID)
        if(_RepPIC[0]) {
          this.RepPICID = _RepPIC[0].EmployeeID
//          this.RepPIC = _RepPIC[0].Name
        }else{
          if(this.Report == this.$store.state.myoffice.OfficeID) {
            this.RepPICID = this.$store.state.employee.EmployeeID
          }
        }
    },

    changePayment: async function () {
        const Office = this.officeList.filter(item => item.OfficeID  == this.Payment)
        console.log("changePayment ", Office[0])
        this.PayCompany = Office[0].CompanyName
        this.PayOffice = Office[0].Name
        this.PayZip = Office[0].Zip
        this.PayAddress = Office[0].Address1 + " " +Office[0].Address2+ " " +Office[0].Address3
//        this.PayDept = Office[0].PICDept
//        this.PayPIC = Office[0].PIC
        this.PayTel = Office[0].Tel
        this.PayFAX = Office[0].FAX

        let employee = await API.graphql(graphqlOperation(employeeByOffice, {OfficeID: this.Payment, limit: 999}))
        let _PayEmployee = employee.data.employeeByOffice.items

        // WEBの利用許可済みの担当者情報のみに絞り込み
        this.PayEmployee = _PayEmployee.filter(function(item, index){ // eslint-disable-line no-unused-vars
          if (!item.Permission.startsWith('0')) return true;
        });

        // 請求先事業所の担当者（責任者？）が設定されていればその担当者をデフォルト
        /*
        const _PayPIC = this.PayEmployee.filter(item => item.EmployeeID == Office[0].PICID)
        if(_PayPIC[0]) {
          this.PayPICID = _PayPIC[0].EmployeeID
          this.Payemail = _PayPIC[0].email
        // 事業所の担当者が設定されておらず、請求先が自事業所の場合は自分を設定
        }else if(this.Payment == this.$store.state.myoffice.OfficeID) {
        */
        // 請求先が自事業所の場合は自分を設定
        if(this.Payment == this.$store.state.myoffice.OfficeID) {
            this.PayPIC = this.$store.state.employee.Name
            this.PayPICID = this.$store.state.employee.EmployeeID
            this.Payemail = this.$store.state.employee.email
        // それ以外の場合は担当者は空欄
        }else {
            this.PayPIC = ""
            this.PayPICID = ""
            this.Payemail = ""
        }
/* 2025/10/30 いらない処理？
        if(this.SamePayAsDelivery) //「依頼者と同じ」がオン
        {
          console.log("SamePayAsDelivery is true")  
          this.Delivery = this.Payment
          await this.changeDelivery()
          this.DelvPICID = this.PayPICID
          this.changeDelvEmployee()
        }
*/
    },
    changeRepEmployee: async function () {
        const employeeList = this.RepEmployee.filter(item => item.EmployeeID  == this.RepPICID)
        if(employeeList[0]) {
          this.RepPIC = employeeList[0].Name
          this.RepDept = employeeList[0].DeptName
//          this.Repemail = employeeList[0].email
//        this.RepTel = employeeList[0].Tel
//        this.RepFAX = employeeList[0].FAX
        }else {
          this.RepPIC = ""
          this.RepDept = ""
//          this.Repemail =""
        }
    },
    changeDelvEmployee: async function () {
        const employeeList = this.DelvEmployee.filter(item => item.EmployeeID  == this.DelvPICID)
        console.log("changeDelvEmployee ", this.DelvPICID)
        console.log("changeDelvEmployee employeeList", employeeList)
        if(employeeList[0]) {
          this.DelvPIC = employeeList[0].Name
          this.Delvemail = employeeList[0].email
          this.DelvDept = employeeList[0].DeptName
        }else {
          this.DelvPIC = ""
          this.Delvemail = ""
          this.DelvDept = ""
        }

        // 報告書宛名が送付先と同じ場合は連動
        if(this.CustomRepCheckbox == false ) {
            this.Report = this.Delivery
            await this.changeReport()
            this.RepPICID = this.DelvPICID
            this.changeRepEmployee()
        }

//        if(this.SamePayAsDelivery) {
//          this.Payment = this.Delivery
//          await this.changePayment()
//          this.PayPICID = this.DelvPICID
//          this.changePayEmployee()
//        }

    },
    changePayEmployee: async function () {
        const employeeList = this.PayEmployee.filter(item => item.EmployeeID  == this.PayPICID)
        this.PayPIC = employeeList[0].Name
        this.PayDept = employeeList[0].DeptName
        this.Payemail = employeeList[0].email
//        this.PayTel = employeeList[0].Tel // Officeの情報なので変えない
//        this.PayFAX = employeeList[0].FAX // Officeの情報なので変えない

/* 2025/10/30 いらない処理？
        if(this.SamePayAsDelivery) {
//          this.Delivery = this.Payment
//          await this.changeDelivery()
          this.DelvPICID = this.PayPICID
          this.changeDelvEmployee()
        }
*/

  },
    selectSamples: async function(selectedSample) {
      if (selectedSample.value) {
        this.TotalPrice = this.TotalPrice + Number(selectedSample.item.Price)
        this.TotalFee = this.TotalFee + Number(selectedSample.item.Fee)
        console.log("selectedSample.Surplus ",selectedSample.item.Surplus)
        if (selectedSample.item.Surplus == "1" ) {
          this.SurplusCount++
        }
      }else{
        this.TotalPrice = this.TotalPrice - Number(selectedSample.item.Price)
        this.TotalFee = this.TotalFee - Number(selectedSample.item.Fee)
        if (selectedSample.item.Surplus == "1" ) {
          this.SurplusCount--
        }
      }
      console.log("SurplusCount ",this.SurplusCount)

      if(this.SurplusCount > 0) {
        this.SurplusFee = 1800
      }else {
        this.SurplusFee = 0
      }

    },
    selectAllSamples: async function(event) {
      var toggle = event.value;
      if (toggle) {
          this.selectedSamples = []
          this.SurplusCount = 0
          for (const sample of this.samples) {
            this.TotalPrice = this.TotalPrice + Number(sample.Price)
            this.TotalFee = this.TotalFee + Number(sample.Fee)
            this.selectedSamples.push(sample)
            if (sample.Surplus == "1" ) {
              this.SurplusCount++
            }
          }
      }else{
        this.selectedSamples = []
        this.SurplusCount = 0
        this.TotalPrice = 0
        this.TotalFee = 0
      }

      if(this.SurplusCount > 0) {
        this.SurplusFee = 1800
      }else {
        this.SurplusFee = 0
      }
    },
    sampleNoukiEdit: async function(item) {
      this.editedIndex = this.samples.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.isSampleNoukiDialog = true
    },
    SampleNoukiSave () {
      if (this.editedIndex > -1) {
        Object.assign(this.samples[this.editedIndex], this.editedItem)
      } else {
        this.samples.push(this.editedItem)
      }
      this.isSampleNoukiDialog = false
    },
    SampleNoukiClose () {
      this.isSampleNoukiDialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },    
    changeOilUsageTimeUnit: async function () {
      if(this.OilUsageTimeUnit) {
        const OilUsageTimeUnitNames = this.useUnits.filter(item => item.Value == this.OilUsageTimeUnit)
        this.OilUsageTimeUnitText = OilUsageTimeUnitNames[0].Text
      }else {
        this.OilUsageTimeUnit = null
        this.OilUsageTimeUnitText = ""
      }
    },
  },
  created () {
    window.addEventListener("beforeunload", this.handler)
  },
  destroyed () {
    window.removeEventListener("beforeunload", this.handler)
  }      
}
</script>
<style scoped>
.agree-text /deep/ label {
    color: black;
}
.wrap-text {
  overflow-wrap: break-all;
  word-break: break-all;
  white-space: pre-line;
}
</style>
